import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as RedirectionIcon } from "../../assets/image/svg/redirectionIcon.svg";
import { Alert, Button, FormControl, MenuItem, Select, Snackbar, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { OrderType, TransformedRealTimeStock, viewOrderRowsData } from "../../types/types";
import { DiscountDetails, eWayBillModalInitialState, EWayBillModalState, FulfillmentInfo, viewManageOrderRowsData } from "./ViewOrderType";
import {
  getSingleOrder,
  updateOrderStatus,
  updateOrder,
  createInvoice,
  getSalesData,
  generateInvoiceIRN,
  updateInvoiceStatus,
  updateInvoice,
  generateEWayBill,
  checkIsEWayBilledApi,
  updateEInvoiceStatus,
  updateEWayBillStatus,
  getOutletApprovalData,
  AggregatedStockData,
} from "../../services/manageOrderService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getMetaData1V2,
  metaData2,
  getEditOrderConfig,
  getViewOrderConfigV2,
  setAndGetViewOrderEditTableHeader,
  getViewOrderExpandableRowsConfig,
} from "./ViewOrderConfig";
import "../manageBasket/ManageBasket.css";
import { Loader } from "../../components/loader/Loader";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BorderHeading from "../../components/heading/BorderHeading";
import FormHeader from "../../components/dms_common/FormHeader";

import {
  checkForEmptyTable,
  checkAllRowsHaveValidStock,
  checkAllRowsHaveValidMOQ,
  createAndDownloadInvoicePdf,
  createSkuWiseStockMap,
  createSkuWiseStockMapForBatchId,
  getBatchCodes,
  getOrderTotalRowData,
  initialDiscountState,
  modifyCartToValidate,
  ordersWithStockExceedingWarning,
  prepareEditOrderReqBody,
  getGenericModalProps,
  initialGenericModalProps,
  GenericModal,
  buttonLoading,
  customStyle,
  showOverlayIn,
  checkIfNHoursPassed,
  transformedStatusForProgressCard,
  cancelEInvoiceAndEWayBillRejectionReasons,
  printBulkInvoicePdfCokeNp,
  checkAllRowsToRemove,
  combineTableRowsWithStock,
  combineTableRowsForCSO,
  stages,
  getSkuToReplacementSkuMap,
  processSkuFulfillment,
  getSkuToMinExpiryDate,
  getBatchCodeQuantities,
  getOrderSummaryFromAllocation,
  calculateFinalStock,
  countInvalidMOQRows,
  countInvalidStockRows,
  transformedStatusForProgressCardV2,
  stagesV2,
  createSkuWiseStockMapWithType,
} from "./ViewOrderUtils";
import "./ViewOrderV2.css"
import CustomTablewithTotalInfoV2 from "../../components/dms_common/CustomTablewithTotalInfoV2";
import { ReactComponent as PdfIcon } from "../../assets/image/svg/pdfIcon.svg";
import {
  createCartProductFromCatalogue,
    formatEditedQuantities,
  getValidateBodyForSKUReplacement,
  getValidateRequestBody,
  isMOQEnabled,
  updateMultiQtyInCart,
  updateQuantityInCart,
} from "../createSecondaryOrder/CreateSecondaryOrderService";
import { analytics, performance ,logLoadTrace} from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { trace, PerformanceTrace } from "firebase/performance";
import NewDiscountModal from "../claimsNew/modals/NewDiscountModal";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import CreateInvoiceModal from "./CreateInvoiceModal";
import { UOM } from "../createSecondaryOrder/CreateSecondaryOrderType";
import { ChannelkartNetworkPost } from "../../services/networkService";
import CircularProgress from "@mui/material/CircularProgress";
import { getAccessToken } from "../../services/authenticationService";
import { fetchBatchDataForSkuList, setRealTimeStockDataInDb } from "../stocks/RealTimeStock/RealTimeStockUtils";
import { PendingButtons, InvoiceOrGrnButton } from "./PendingButtons";
import { ReactComponent as DisclaimerIcon } from "../../assets/image/svg/disclaimer.svg";
import Search from "../../components/dms_common/Search";
import { getDataFromLocalDb, insertDataIntoLocalDB } from "../../services/dbService";
import { createCatalogue, performUomConversion } from "../../services/catalogueService";
import { getConfigData } from "../../services/configurationService";
import { filterData, searchWithStatusFilter } from "../../components/dms_common/DmsCommonServices";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import { Cart, Catalogue } from "../createSecondaryOrder/models";
import "./ViewOrder.css";
import OrderProgressCardV2 from "./OrderProgressCardV2";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import { getQuantityType, truncateToTwoDecimals ,isUserAllowedToEdit, handleScroll, createScrollHandler} from "../../components/dms_common/DmsUtils";
import OrderCancelModal from "./OrderCancelModal";
import { downloadGrnReport } from "../../services/manageReportService";
import EWayBillModal from "./EWayBillModal";
import { determineOrderType } from "../../components/dms_common/useQuery";
import useShortcutKeys from "../../components/dms_common/ShortcutKeys";
import CreateInvoiceModalReplacementSKU from "./CreateInvoiceModalReplacementSKU";
import CustomAccordianV2 from "../../components/dms_common/CustomAccordianV2";
import TextSwitcher, { TextSwitcherItemObject } from "../../components/dms_common/TextSwitcher";
import SearchV2 from "../../components/dms_common/SearchV2";
import InfoDropDown from "./InfoDropDown";

export type ColumnsMetadataType = {
  "index": number;
  "width": number;
}
export type ColumnsConfiguration = Record<string,ColumnsMetadataType[]>;

const ViewOrderV2 = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    fetchPricingBySalesrep,
    batchIdConfiguration = false
  } = ConfigDictionary;
  const { orderId, loadNumber } = useParams();
  const [rows, setRows] = useState<viewManageOrderRowsData[]>([]);
  const [loader, setLoader] = useState(true);
  const [totalFooterValue, setTotalFooterValue] = useState<any[]>([]);
  const [orderData, setOrderData] = useState<any>({});
  const [invoiceExpired, setInvoiceExpired] = useState<boolean>(false);
  const [orderTrackingConfig, setOrderTrackingConfig] = useState<any[]>([]);
  const [isScrolling, setIsScrolling] = useState(false);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [discount, setDiscount] = useState<DiscountDetails>(initialDiscountState);
  const [selectedSkuCode, setSelectedSkuCode] = useState<any>({});
  const [cart, setCart] = useState<Cart>({});
  const [catalogue, setCatalogue] = useState<Catalogue[]>([]);
  const [orderStatusChangeLoading, setOrderStatusChangeLoading] = useState<string>("");
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(initialGenericModalProps);
  const [canPushToEInvoice, setCanPushToEInvoice] = useState<boolean>(false);
  const [TableHeaders, SetViewOrderEditTableHeader] = useState<Record<string, string>>({});
  const [saveChangesLoading, setSaveChangesLoading] = useState<boolean>(false);
  const [editLoading, setEditLoading] = useState<boolean>(false);
  const [orderCancelModalOpen, setOrderCancelModalOpen] = useState<boolean>(false);
  const [selectedRejectionReason, setSelectedRejectionReason] = useState<string>(``);
  const [rejectionReasons, setRejectionReasons] = useState<string[]>([]);
  const [invoiceReportName, setInvoiceReportName] = useState<string>("");
  const [invoiceTaskName, setInvoiceTaskName] = useState<string>("");

  const [isProcessing, setIsProcessing] = useState(false);
  const [filteredRows, setFilteredRows] = useState<viewManageOrderRowsData[]>([]);
  const hideAddMoreInEditOrder = useRef<boolean>(false);
  const hideAdditionalDistributorDiscount = useRef<boolean>(false);
  const useNewOrderStatusUpdateAPI = useRef<boolean>(false);
  const disableStockCheck = useRef<boolean>(false);
  const enableRemainingStocksLabel = useRef<boolean>(false);
  const disableSchemeCheck = useRef<boolean>(false);
  const hideItemLevelTaxInfo = useRef<boolean>(false);
  const hideItemLevelDiscountInfo = useRef<boolean>(false);
  const hideCouponDiscount = useRef<boolean>(false);
  const cokenpFlatTaxAmountField = useRef<boolean>(false);
  const showGoToInvoiceRedirectionButton = useRef<boolean>(false);
  const disableEditInvoiceFlow = useRef<boolean>(false);
  const hideOrderProgressCard = useRef<boolean>(false);
  const [isDownloading, setIsDownloading] = useState<boolean>(false); // New state to track full download process
  const [eWayBillModalState, setEWayBillModalState] = useState<EWayBillModalState>(eWayBillModalInitialState);
  const [rejectionReasonString, setRejectionReasonString] = useState<string>("")
  const disableOrderEdit = useRef<boolean>(false);
  const disableOrderStatusChange = useRef<boolean>(false);
  const [disableOrderEditDesignationBased, setDisableOrderEditDesignationBased] = useState<boolean>(false);
  const [disableCreateInvoiceDesignationBased, setDisableCreateInvoiceDesignationBased] = useState<boolean>(false);
  const [orderEditAllowedRoles, setOrderEditAllowedRoles] = useState<string[]>([]);
  const [createInvoiceDisableRoles, setCreateInvoiceDisableRoles] = useState<string[]>([]);
  const [isOutletApproved ,setIsOutletApproved] = useState<boolean>(true)
  const [outletApprovalData, setOutletApprovalData] = useState<any>()
  const allowUnapprovedOutlets = useRef<boolean>(false);
  const isCounterSaleOrder = useRef<boolean>(false);
  const outletReferenceId = useRef<string>("")
  const columnsConfigurationRef = useRef<ColumnsConfiguration | undefined>(undefined)
  const editButtonRef = useRef<HTMLButtonElement>(null);
 
  const cartDbInitialData = useRef<Record<string, string>>({});
  const couponLabel = useRef<string>("Coupon Discount")
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const viewQpsFocInSummary = useRef<boolean>(false);
  const enableMOQCheck = useRef<boolean>(false)
  const cancelOrder = useRef<boolean>(false)
 const orderType = determineOrderType(location?.pathname);
   const { ctrlKey, positiveCta, negativeCta } = useShortcutKeys();
  const { aggregateStockSummaryMap, isBulkPanel = false, isPartialOrder = false } : {aggregateStockSummaryMap: Map<string, AggregatedStockData>, isBulkPanel: boolean, isPartialOrder: boolean} = location.state || {};

  const [scrollTop, setScrollTop] = useState<number>(0); 
  const scrollRef = useRef<HTMLDivElement>(null);
  const [allowTableScroll, setAllowTableScroll] = useState<boolean>(false);
  const [dontAllowContainerScroll, setDontContainerScroll] = useState(true);
  const [disableActionButtons, setDisableActionButtons] = useState(false);
  
  const orderConfirmationEnabled = useRef<boolean>(true);
  const orderUomCheck = useRef<string>("");
  const performSkuReplacement = useRef<boolean>(false);
  const originalSkuFulfillmentMapRef = useRef<Map<string, FulfillmentInfo>>(new Map());
  const newOrderDataAfterReplacement = useRef<any>();
  const skuNameMap = useRef<Map<string, string>>(new Map());
  const openingInvoiceModalRef = useRef<boolean>(false);
  const enableSKUReplacement = useRef<boolean>(false);
  const [openingInvoiceModalState, setOpeningInvoiceModalState]=useState<boolean>(false);
  const willOrderGetPartiallyInvoiced = useRef<boolean>(false);
  const willGetRejected = useRef<boolean>(false);

  const ACCESS_TOKEN = getAccessToken() ?? "";

  const insideManageInvoice = location?.pathname?.includes("viewInvoice") || location?.pathname?.includes("delivery/loadouts/preseller");
  const insidePresellerLoadout = location?.pathname?.includes("delivery/loadouts/preseller");
  // those rows are valid which are not a free product
  const validRows = [...rows]?.filter((row: viewManageOrderRowsData) => !row?.freeItem);


  const savedFilter = sessionStorage.getItem("bulkInvoiceFilterData");
  let currentFilterState: {
    filteredRows?: any[];
    filterType?: string;
    isFilterActive?: boolean;
  } = {};

  if (savedFilter) {
    try {
      currentFilterState = JSON.parse(savedFilter);
    } catch (err) {
      currentFilterState = {};
    }
  }

  const handleUpdateBulkInvoiceFilterData = (orderId: string) => {
    const data = currentFilterState.filteredRows ?? []
    currentFilterState.filteredRows = data.filter((id: any) => id !== orderId)
    sessionStorage.setItem("bulkInvoiceFilterData", JSON.stringify(currentFilterState))
  }
  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsScrolling(!isExpanded);
  }
  const canEditOrder = () => {
    if (orderData?.status?.toUpperCase() === "REJECTED" ||
        orderData?.status?.toUpperCase() === "CANCELLED" ||
        orderData?.status?.toUpperCase() === "OUT FOR DELIVERY" ||
        orderData?.status?.toUpperCase() === "DELIVERED" ||
        orderData?.status?.toUpperCase() === "PARTIAL DELIVERED" ||
        (orderData?.status?.toUpperCase() === "PARTIALLY INVOICED" && !insideManageInvoice) ||
        (orderData?.status?.toUpperCase() === "INVOICED" && !insideManageInvoice)) return false;
    if (disableOrderEditDesignationBased && !insideManageInvoice) {
      return (
        isUserAllowedToEdit(orderEditAllowedRoles) &&
        !invoiceExpired &&
        isOutletApproved
      );
    }

    return (
      !orderData?.eInvoiced &&
      !invoiceExpired &&
      isOutletApproved &&
      !Boolean(disableOrderEdit.current) &&
      !insidePresellerLoadout
    );
  };
  const [isEditing, setIsEditing] = useState<boolean>(canEditOrder());

  const handlePromotionModalVisibility = (paramRow: any) => {
    setSelectedSkuCode(( batchIdConfiguration && insideManageInvoice && !isEditing) ? paramRow?.batchId : paramRow?.batchCode);
    dispatch(setDiscountModalState(true));
  };

  const handleOrderStatusChange = async (id: string) => {
    const isCancellingOrderOrInvoice: boolean = id?.toUpperCase() == "REJECTED" || id?.toUpperCase() == "CANCELLED" ;

    let requestBody;

    if (orderData.eInvoiced) {
      // Special request body for e-way bill cancellation
      requestBody = {
        invoiceNumber: orderData?.invoiceNumber,
        cancelReason: cancelEInvoiceAndEWayBillRejectionReasons[selectedRejectionReason],
        cancelRemarks: cancelEInvoiceAndEWayBillRejectionReasons[selectedRejectionReason] === "4" ? rejectionReasonString : selectedRejectionReason,
      };
    } else { 
      const cancelInvoicePayload = insideManageInvoice
      ? { invoiceNumber: orderData?.invoiceNumber }
      : {};

    const cancelInvoiceOrOrderPayload = isCancellingOrderOrInvoice
      ? { statusReason: selectedRejectionReason }
      : {};

    requestBody = {
      status: id,
      ...cancelInvoicePayload,
      ...cancelInvoiceOrOrderPayload,
    };
    }
   

    setOrderStatusChangeLoading(id);

    try {
      if(orderData.eInvoiced){
        await handleCancelEInvoiceOrEWayBill(requestBody);
        return;
      }
      else if (insideManageInvoice) {
        await updateInvoiceStatus(requestBody);
        if(isCancellingOrderOrInvoice) {
          logEvent(analytics, "secondary_invoice_cancelled", {
            "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
            "invoice_id": orderData?.id ?? null,
            "rejected_skus": (orderData?.orderDetails?.map((s: any) => s?.batchCode) || []).join(",") || "",
            "rejected_qty": orderData?.normalizedQuantity || "",
            "final_amount": orderData?.netAmount || "",
            "total_discount": orderData?.discountInfo?.[0]?.discount || "",
            "rejection_reason": selectedRejectionReason || "",
          });
        }
        navigate(ConfigDictionary?.mergeManageOrderInvoice ? "/dashboard/sale/manageOrders" : "/dashboard/sale/manageInvoices");
      } else {
        if(id?.toUpperCase() == "CONFIRMED") {
          logEvent(analytics, "secondary_order_confirmed", {
            "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
            "order": orderData?.id ?? null,
            "confirmed_skus": (orderData?.orderDetails?.map((s: any) => s?.batchCode) || []).join(",") || "",
            "confirmed_qty": orderData?.normalizedQuantity || "",
            "final_amount": orderData?.netAmount || "",
            "total_discount": orderData?.discountInfo?.[0]?.discount || "",
          });
        } else if(isCancellingOrderOrInvoice) {
          logEvent(analytics, "secondary_order_rejected", {
            "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
            "order": orderData?.id ?? null,
            "rejected_skus": (orderData?.orderDetails?.map((s: any) => s?.batchCode) || []).join(",") || "",
            "rejected_qty": orderData?.normalizedQuantity || "",
            "final_amount": orderData?.netAmount || "",
            "total_discount": orderData?.discountInfo?.[0]?.discount || "",
          });
        }
        await updateOrderStatus(requestBody, orderData?.orderNumber, useNewOrderStatusUpdateAPI.current);
        await getOrderDetails(
          orderId ? orderId : insideManageInvoice ? orderData?.orderNumber : orderData?.id
        );

        handleUpdateBulkInvoiceFilterData(orderData?.id);
        resetGenericModalProps();
      }
    } catch (e) {
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `Error while updating ${insideManageInvoice ? `invoice` : `order`} status`
        )
      );
    } finally {
      setOrderStatusChangeLoading("");
      if (isCancellingOrderOrInvoice) resetRejectOrderState();
    }
  };


  const handleCancelEInvoiceOrEWayBill  = async (requestBody: any) => {
    if (openInvalidOrderModal()) return;
    try {
      const res = orderData?.eWayBilled ? await updateEWayBillStatus(requestBody) : await updateEInvoiceStatus(requestBody);
      const data = res?.data;

      if (`status` in data) {
        console.error(data?.errorMessage);
        setGenericModalProps(
          getGenericModalProps(
            "error",
            data?.errorMessage ?? `Some error occured while cancelling ${orderData?.eWayBilled ? "e-way Bill" : "e-Invoice"}`
          )
        );
      } else if (data?.[`Status`] === 0) {
        const errors: string | any[] = Array.isArray(data?.[`ErrorDetails`])
          ? data?.[`ErrorDetails`]
          : `Some error occured while cancelling ${orderData?.eWayBilled ? "e-way Bill" : "e-Invoice"}`;
        setGenericModalProps(getGenericModalProps("error", errors));
        console.error(errors);
      } else if (data?.[`Irn`] && data?.[`CancelDate`]) {
        await getOrderDetails(orderId ?? orderData?.orderNumber ?? "");
        setGenericModalProps(
          getGenericModalProps(
            "success",
            data?.errorMessage ?? `${orderData?.eWayBilled ? "e-way Bill" : "e-Invoice"} cancelled.`,
            "Continue",
            undefined,
            () => setGenericModalProps(initialGenericModalProps),
            undefined,
            "0px 50px 0px 50px"
          )
        );
      }
    } catch (e) {
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `Some error occured while cancelling ${orderData?.eWayBilled ? "e-way Bill" : "e-Invoice"}`
        )
      );
    } finally {
      setOrderStatusChangeLoading("");
    }


  }

  const resetRejectOrderState = () => {
    setOrderCancelModalOpen(false);
    setSelectedRejectionReason("");
    setRejectionReasonString("")
  };


  const handleCreateInvoice = async (invoiceNumber: string = "", viewInvoice: boolean = false) => {
    // Start a custom trace for view secondary order page load time
    if (disableActionButtons) return;
    const pageLoadTrace: PerformanceTrace = trace(performance, "view_secondary_order_invoice_create_invoice_time");
    pageLoadTrace.start();
    try {
      setOrderStatusChangeLoading(viewInvoice ? "VIEW_INVOICE" : "INVOICE");

      if (!checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current)){
        setGenericModalProps(
          getGenericModalProps("error", "Ordered quantity is less than the Minimum Billable Quantity. Invoice cannot be confirmed.")
        );
        setOrderStatusChangeLoading("");
        return
      }

      // when we are opening an order with status "INVOICED"
      if (invoiceNumber) {
        const blobKey = await createAndDownloadInvoicePdf([invoiceNumber]);
        return blobKey[0];
      }

      // when the order status is confirmed, first we need to handle the applied discount and change its status to "INVOICED"
      const discountPayload = {
        orderNumber: orderData?.orderNumber,
        discountType: discount?.discountType?.toLocaleLowerCase() ?? "value",
        discountValue: parseFloat(discount?.discountValue || "0"),
      };

      // api call to change the order status and send discount data
      const response = await createInvoice(discountPayload);

      if (response?.status === 200) {

        let rejectedOrder: boolean = (response?.data?.status?.toUpperCase() === "REJECTED") ?? false;
        handleUpdateBulkInvoiceFilterData(orderData?.id);
        if(ConfigDictionary?.mergeManageOrderInvoice && !rejectedOrder) {
          navigate(
            `/dashboard/sale/manageInvoices/viewInvoice/${
              orderData?.orderNumber ?? ""
            }`
          )
        }else {
          await getOrderDetails(orderId ?? orderData?.id ?? "");
        }
      } else {
        setGenericModalProps(getGenericModalProps("error", "Error while creating invoice"));
      }
    } catch (error) {
      console.error(error);
      setGenericModalProps(
        getGenericModalProps("error", "Error while creating / downloading invoice pdf")
      );
    } finally {
      setModalOpen(false);
      setOrderStatusChangeLoading("");
      pageLoadTrace.stop();
    }
  };

  const handleCreateEWayBillPdf = async (invoiceNumber: string = "", viewEWayBill: boolean = false) => {
    try {
      setOrderStatusChangeLoading(viewEWayBill ? "VIEW_E_WAY_BILL" : "DOWNLOAD_E_WAY_BILL");
      const blobKey = await createAndDownloadInvoicePdf([invoiceNumber], true);
      return blobKey[0];

    } catch (error) {
      console.error(error);
      setGenericModalProps(
        getGenericModalProps("error", "Error while creating / downloading e-way bill pdf")
      );
    } finally {
      setModalOpen(false);
      setOrderStatusChangeLoading("");
    }
  };

  const downloadReportTaskPdf = async()=> {
    if (isDownloading) return; 
    if (openInvalidOrderModal()) return;
    try {
      setIsDownloading(true);
      await downloadGrnReport(
        invoiceReportName,
        "invoiceNumber",
        String(orderData?.invoiceNumber),
        setSnackbarOpen,
        setIsDownloading
      ); 
    }catch(e) {
      setGenericModalProps(getGenericModalProps("error", "Error while creating invoice pdf"));
      setIsDownloading(false);
    }
  }

  const handlePrintInvoice = async (viewInvoice: boolean = false) => {
    if (openInvalidOrderModal()) return;

    try {
      const blobKey = await handleCreateInvoice(orderData?.invoiceNumber, viewInvoice);
      if (!blobKey || !ACCESS_TOKEN) {
        console.error("Invalid URL or access token.");
        setGenericModalProps(getGenericModalProps("error", "Invalid URL or access token."));
        return;
      }
      const fileMetaId = blobKey.split("/").pop();
      const serverUrl = EnvironmentRegistry.getServerUrl();
      const pdfUrl = viewInvoice
        ? `${serverUrl}/v1/media/viewPdf/${fileMetaId}?access_token=${ACCESS_TOKEN}`
        : `${blobKey}?access_token=${ACCESS_TOKEN}`;
      window.open(pdfUrl, "_blank");
      logEvent(analytics, "secondary_invoice_report_downloaded", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "invoice_id": orderData?.id ?? null,
        "download_format": "pdf",
      });
    } catch (e: any) {
      logEvent(analytics, "secondary_invoice_download_failed", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "invoice_id":orderData?.id,
        "error_reason": e.toString(),
      });
      setGenericModalProps(getGenericModalProps("error", "Error while creating invoice pdf"));
    }
  };


    const handlePrintInvoiceCokeNp = async () => {
       if (isDownloading) return; 
       if (openInvalidOrderModal()) return;

      try {
        setIsDownloading(true)
        const blobKey = await printBulkInvoicePdfCokeNp([String(orderData?.invoiceNumber)]);
  
        if (!blobKey?.[0] || !ACCESS_TOKEN) {
          console.error("Invalid URL or access token.");
          setGenericModalProps(getGenericModalProps("error", "Invalid URL or access token."));
          return;
        }
  
        const pdfUrl = `${blobKey?.[0]}?access_token=${ACCESS_TOKEN}`;
        window.open(pdfUrl, "_blank");
 
        logEvent(analytics, "secondary_invoice_report_downloaded", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "invoice_id": orderData?.id ?? null,
          "download_format": "pdf",
        });
        
      } catch(e:any) {
        logEvent(analytics, "secondary_invoice_download_failed", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "invoice_id":orderData?.id,
          "error_reason": e.toString(),
        });
        setIsDownloading(false)
        console.error(e)
        setGenericModalProps(
          getGenericModalProps("error", "Error while fetching pdf url")
        );
      }finally {
        setIsDownloading(false)
      }
    }

  const handlePrintEWayBill = async (viewEWayBill: boolean = false) => {
    if (openInvalidOrderModal()) return;

    try {
      const blobKey = await handleCreateEWayBillPdf(orderData?.invoiceNumber, viewEWayBill);
      if (!blobKey || !ACCESS_TOKEN) {
        console.error("Invalid URL or access token.");
        setGenericModalProps(getGenericModalProps("error", "Invalid URL or access token."));
        return;
      }
      const fileMetaId = blobKey.split("/").pop();
      const serverUrl = EnvironmentRegistry.getServerUrl();
      const pdfUrl = viewEWayBill
        ? `${serverUrl}/v1/media/viewPdf/${fileMetaId}?access_token=${ACCESS_TOKEN}`
        : `${blobKey}?access_token=${ACCESS_TOKEN}`;
      window.open(pdfUrl, "_blank");
      logEvent(analytics, "secondary_e_way_bill_downloaded", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "invoice_id": orderData?.id ?? null,
        "download_format": "pdf",
      });
    } catch (e: any) {
      logEvent(analytics, "secondary_e_way_bill_download_failed", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "invoice_id":orderData?.id,
        "error_reason": e.toString(),
      });
      setGenericModalProps(getGenericModalProps("error", "Error while creating e-way bill pdf"));
    }
  };



  const handlePushToEInvoice = async () => {
    if (openInvalidOrderModal()) return;
    setOrderStatusChangeLoading("E_INVOICE");
    try {
      const res = await generateInvoiceIRN(orderData?.invoiceNumber);
      const data = res?.data;

      if (`status` in data) {
        console.error(data?.errorMessage);
        setGenericModalProps(
          getGenericModalProps(
            "error",
            data?.errorMessage ?? `Some error occured while e-invoicing`
          )
        );
      } else if (data?.[`Status`] === 0) {
        const errors: string | any[] = Array.isArray(data?.[`ErrorDetails`])
          ? data?.[`ErrorDetails`]
          : `Some error occured while e-invoicing`;
        setGenericModalProps(getGenericModalProps("error", errors));
        console.error(errors);
      } else if (data?.[`Status`] === `ACT`) {
        await getOrderDetails(orderId ?? orderData?.orderNumber ?? "");
        setGenericModalProps(
          getGenericModalProps(
            "success",
            data?.errorMessage ?? `Invoice No. ${orderData?.invoiceNumber} pushed to e-invoice.`,
            "Continue",
            undefined,
            () => setGenericModalProps(initialGenericModalProps),
            undefined,
            "0px 50px 0px 50px"
          )
        );
      }
    } catch (e) {
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `Some error occured while e-invoicing`
        )
      );
    } finally {
      setOrderStatusChangeLoading("");
    }
  };

  const handleGenerateEWayBill = async () => {
    if (openInvalidOrderModal()) return;
    if(eWayBillModalState.data.length < 15) {
      setEWayBillModalState({...eWayBillModalState, validationError: true})
      return
    }
    setOrderStatusChangeLoading("E_WAY_BILL");
    try {
      const res = await generateEWayBill(orderData?.invoiceNumber, eWayBillModalState.data);
      const data = res?.data;

      if (`status` in data) {
        console.error(data?.errorMessage);
        setEWayBillModalState(eWayBillModalInitialState);
        setGenericModalProps(
          getGenericModalProps(
            "error",
            data?.errorMessage ?? `Some error occured while generating e-way bill`
          )
        );
      } else if (data?.[`Status`] === 0) {
        const errors: string | any[] = Array.isArray(data?.[`ErrorDetails`])
          ? data?.[`ErrorDetails`]
          : `Some error occured while generating e-way bill`;
        setEWayBillModalState(eWayBillModalInitialState);
        setGenericModalProps(getGenericModalProps("error", errors));
        console.error(errors);
      } else if (data?.[`EwbNo`]  && data?.[`EwbDt`]) {
        await getOrderDetails(orderId ?? orderData?.orderNumber ?? "");
        setEWayBillModalState(eWayBillModalInitialState);
        setGenericModalProps(
          getGenericModalProps(
            "success",
            data?.errorMessage ?? `E-way bill generated for Invoice No. ${orderData?.invoiceNumber}`,
            "Continue",
            undefined,
            () => setGenericModalProps(initialGenericModalProps),
            undefined,
            "0px 50px 0px 50px"
          )
        );
      }
    } catch (e) {
      setEWayBillModalState(eWayBillModalInitialState);
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `Some error occured while generating e-way bill`
        )
      );
    } finally {
      setOrderStatusChangeLoading("");
    }
  };

  const handleOnBlur = (paramRow: any) => {
    if (!canEditOrder()) return;
    if (ConfigDictionary?.uomConversion) {
      const {
        batchCode,
        caseQuantity,
        otherUnitQuantity,
        pieceQuantity,
        casePrice,
        otherUnitPrice,
        price,
        availableStock,
        caseToPieceQty,
        otherToPieceQty,
        otherUnitName,
        uom,
      } = paramRow ?? {};
      const { convertedCaseQty, convertedOtherQty, convertedPieceQty } = performUomConversion(
        caseQuantity,
        otherUnitQuantity,
        pieceQuantity,
        uom,
        caseToPieceQty,
        otherToPieceQty,
        availableStock?.cs,
        availableStock?.other,
        availableStock?.pc,
        true,
        otherUnitName
      );

      updateMultiQtyInCart(
        batchCode,
        {
          caseQuantity: convertedCaseQty,
          otherUnitQuantity: convertedOtherQty,
          pieceQuantity: convertedPieceQty,
        },
        { outletCode: orderData?.outletCode },
        catalogue,
        setCart
      );

      setRows((prevRows) =>
        prevRows?.map((row) =>
          row?.batchCode === paramRow?.batchCode
            ? {
                ...row,
                caseQuantity: convertedCaseQty,
                otherUnitQuantity: convertedOtherQty,
                pieceQuantity: convertedPieceQty,
                actualAmount: `${
                  +row?.actualAmount -
                  (caseQuantity * casePrice +
                    otherUnitQuantity * otherUnitPrice +
                    pieceQuantity * price) +
                  (convertedCaseQty * casePrice +
                    convertedOtherQty * otherUnitPrice +
                    convertedPieceQty * price)
                }`,
              }
            : row
        )
      );
    }
  };

const handleQuantityChange = (
  paramRow: any,
  changedQuantity: number,
  type: UOM
) => {
  if (changedQuantity < 0) return;
  if (!canEditOrder()) return;

  const quantityKey =
    type === UOM.CASE
      ? "caseQuantity"
      : type === UOM.OTHER
      ? "otherUnitQuantity"
      : "pieceQuantity";

  const priceKey =
    type === UOM.CASE
      ? "casePrice"
      : type === UOM.OTHER
      ? "otherUnitPrice"
      : "price";

  if (!ConfigDictionary?.uomConversion) {
    updateQuantityInCart(
      paramRow?.batchCode,
      changedQuantity,
      type,
      { outletCode: orderData?.outletCode },
      catalogue,
      setCart
    );
  }

  setRows((prevRows) =>
    prevRows?.map((row) => {
      if (row?.batchCode !== paramRow?.batchCode) return row;

      const newRow = {
        ...row,
        [quantityKey]: changedQuantity,
        actualAmount: `${
          Number(row?.actualAmount) -
          paramRow[quantityKey] * paramRow[priceKey] +
          changedQuantity * paramRow[priceKey]
        }`,
      };

      // ✅ compute hasChanged
      const hasChanged =
        newRow?.actualCaseQuantity !== newRow?.caseQuantity ||
        newRow?.actualPieceQuantity !== newRow?.pieceQuantity ||
        newRow?.actualOtherUnitQuantity !== newRow?.otherUnitQuantity;

      return { ...newRow, hasChanged };
    })
  );
};

const updateQuantityAndBlur = (
  paramRow: viewManageOrderRowsData,
  newQuantity: number,
  type: UOM
) => {
  if (!isEditing) return;
  if (!canEditOrder()) return
  const quantityKey =
    type === UOM.CASE
      ? "caseQuantity"
      : type === UOM.OTHER
      ? "otherUnitQuantity"
      : "pieceQuantity";

  const priceKey =
    type === UOM.CASE
      ? "casePrice"
      : type === UOM.OTHER
      ? "otherUnitPrice"
      : "price";

  setRows((prevRows) =>
    prevRows.map((row) => {
      if (row.batchCode !== paramRow.batchCode) return row;

      const oldQty = Number(row[quantityKey] || 0);
      const oldAmount = Number(row.actualAmount || 0);
      const price = Number(row[priceKey] || 0);

      // 🛑 Clamp newQuantity to non-negative
      const safeNewQty = Math.max(0, newQuantity);

      // If clamped quantity is the same as old, no recalculation needed
      if (safeNewQty === oldQty) {
        return row;
      }

      let updatedRow: viewManageOrderRowsData = {
        ...row,
        [quantityKey]: safeNewQty,
        actualAmount: `${oldAmount - oldQty * price + safeNewQty * price}`,
      };

      // Apply conversion if enabled
      if (ConfigDictionary?.uomConversion) {
        const { convertedCaseQty, convertedOtherQty, convertedPieceQty } =
          performUomConversion(
            updatedRow.caseQuantity,
            updatedRow.otherUnitQuantity,
            updatedRow.pieceQuantity,
            updatedRow.uom ?? "all",
            updatedRow.caseToPieceQty,
            updatedRow.otherToPieceQty,
            updatedRow.availableStock?.cs,
            updatedRow.availableStock?.other,
            updatedRow.availableStock?.pc,
            true,
            updatedRow.otherUnitName
          );

        const casePriceNum = Number(updatedRow.casePrice || 0);
        const otherPriceNum = Number(updatedRow.otherUnitPrice || 0);
        const piecePriceNum = Number(updatedRow.price || 0);

        updatedRow = {
          ...updatedRow,
          caseQuantity: convertedCaseQty,
          otherUnitQuantity: convertedOtherQty,
          pieceQuantity: convertedPieceQty,
          actualAmount: `${convertedCaseQty * casePriceNum +
            convertedOtherQty * otherPriceNum +
            convertedPieceQty * piecePriceNum}`,
        };

        updateMultiQtyInCart(
          updatedRow.batchCode,
          {
            caseQuantity: convertedCaseQty,
            otherUnitQuantity: convertedOtherQty,
            pieceQuantity: convertedPieceQty,
          },
          { outletCode: orderData?.outletCode },
          catalogue,
          setCart
        );
      }

      updatedRow.hasChanged =
        Number(updatedRow.actualCaseQuantity || 0) !== updatedRow.caseQuantity ||
        Number(updatedRow.actualPieceQuantity || 0) !==
          updatedRow.pieceQuantity ||
        Number(updatedRow.actualOtherUnitQuantity || 0) !==
          updatedRow.otherUnitQuantity;

      return updatedRow;
    })
  );
};





  const handleRemove = (paramRow: any) => {
    if (!canEditOrder() || paramRow?.freeItem) return;
    updateMultiQtyInCart(
      paramRow?.batchCode,
      {
        caseQuantity: 0,
        otherUnitQuantity: 0,
        pieceQuantity: 0,
      },
      { outletCode: orderData?.outletCode },
      catalogue,
      setCart
    )
    setRows((prevRows) =>
      prevRows?.filter(
        (row) =>
          !(
            row?.batchCode === paramRow?.batchCode &&
            row?.freeItem === paramRow?.freeItem
          )
      )
    );
  };

  const handleReset = async () => {
    setSearchedValue("");
    await setDataRowAndFooter(orderData);
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const populateCartDuringEditOrder = async (data: any) => {
    try {
      
      let orderedBatchCodes: string | string[] =
      getBatchCodes(
        data?.orderDetails
          ?.map((item: any) => item?.type !== "freeItem" ? item : null)
          ?.filter(Boolean)
      ) ?? "";
        
      orderedBatchCodes = orderedBatchCodes?.split(",") ?? []
      const pricingData = await createCatalogue(OrderType.SECONDARY, data?.outletCode, !disableSchemeCheck.current, orderedBatchCodes, (fetchPricingBySalesrep && fetchPricingBySalesrep) ? data?.loginId : undefined, undefined, undefined, data?.supplier);

      if (pricingData && Array.isArray(pricingData) && pricingData?.length == 0) {
        setGenericModalProps(
          getGenericModalProps("error", "Some items in this order could not be edited due to missing/incorrect pricing data. Please update the data in the MDM & Integration Page.")
        );
        return "invalidPricing"
      }

      const catalogueData = await getDataFromLocalDb("Catalogue");
      setCatalogue(catalogueData?.data);
      let combinedOrderDetails = data?.orderDetails
      if (batchIdConfiguration && insideManageInvoice) combinedOrderDetails = combineTableRowsForCSO(JSON.parse(JSON.stringify(data?.orderDetails)));
      (combinedOrderDetails ?? [])
        ?.filter((sku: any) => sku?.type !== "freeItem")
        ?.forEach((order: any) => {
          const {
            batchCode,
            caseQuantity,
            pieceQuantity,
            otherUnitQuantity,
            initialNormalizedQuantity,
          } = order;
          if (initialNormalizedQuantity > 0) {
            updateMultiQtyInCart(
              batchCode,
              {
                caseQuantity: caseQuantity,
                otherUnitQuantity: otherUnitQuantity,
                pieceQuantity: pieceQuantity,
              },
              { outletCode: data?.outletCode },
              catalogueData?.data,
              setCart
            );
          }
        });
    } catch (err: any) {
      console.error(err);
      if (err?.message === "pricing") {
        setGenericModalProps(
          getGenericModalProps("error", "⚠️  Unable to fetch pricing details. Please try again later.",
            "Ok",
            ``,
            () => {
              setGenericModalProps(initialGenericModalProps)
            }
          ));
      } else if (err?.message === "offers") {
        setGenericModalProps(
          getGenericModalProps("error", "⚠️  Unable to load offer details. Please refresh or try again.",
            "Ok",
            ``,
            () => {
              setGenericModalProps(initialGenericModalProps)
            }
          )
        );
      } else {
        setGenericModalProps(
          getGenericModalProps("error", `Order with Id ${orderId} not found`)
        );
      }
    }
  };

  const createStockData = async (batchCodes: string = "", isPendingOrder: boolean, supplier: string | undefined) => {
    try {
      setOrderStatusChangeLoading("STOCKS");
      const BATCH_SIZE = 100;
      const orderedBatchCodes: string[] = batchCodes?.split(",").map(code => code.trim()).filter(Boolean) ?? [];

      let stocksData: any[] = [];
      for (let i = 0; i < orderedBatchCodes?.length; i += BATCH_SIZE) {
        const chunk = orderedBatchCodes.slice(i, i + BATCH_SIZE);
        const chunkString = chunk.join(",");
        const chunkStockData = await setRealTimeStockDataInDb(chunkString, getQuantityType(), supplier);
        stocksData = stocksData.concat(chunkStockData);
      }
      let stocksDataResult = await createSkuWiseStockMapWithType(stocksData, isPendingOrder, aggregateStockSummaryMap);
      return stocksDataResult;
    } catch (e) {
      console.error(e);
      setGenericModalProps(getGenericModalProps("error", "⚠️  Unable to fetch stocks data"));
    } finally {
      setOrderStatusChangeLoading("");
    }
  };

  const setDataRowAndFooter = async (
    data: any,
    tableRows: viewManageOrderRowsData[] = [],
    tableHeaders?: Record<string, string>
  ) => {
    try {
      let stocksData: any = {};

      if(!disableStockCheck.current) {
        const orderedBatchCodes: string = getBatchCodes(data?.orderDetails) ?? "";
        stocksData = await createStockData(orderedBatchCodes, "PENDING" === data?.status?.toUpperCase(), data?.supplier);
      }

      const dbResult = await getDataFromLocalDb("Product");
      const products: any = dbResult?.data?.[0]?.data ?? {};

      if (tableRows?.length) {
        // First, group rows by batchCode and combine them
        if (batchIdConfiguration && insideManageInvoice) {
          const combinedRows = combineTableRowsWithStock(tableRows, stocksData, true);
          setRows(combinedRows);
          return;
        } else {
          const updatedRows = tableRows?.map((row: viewManageOrderRowsData) => {
          const skuStock = stocksData?.[row?.batchCode + '-' + ("freeItem" === row?.type ? "foc" : "normal")]; 
          const {
            availableCaseQty,
            availablePieceQty,
            availableOtherQty,
            actualAvailableCaseQty,
            actualAvailablePieceQty,
            actualAvailableOtherQty,
            committedCaseQty,
            committedPieceQty,
            committedOtherQty,
          } = skuStock || {};
          const availableStock = {
            cs: availableCaseQty || 0,
            pc: availablePieceQty || 0,
            other: availableOtherQty || 0,
            actualAvailableCaseQty,
            actualAvailablePieceQty,
            actualAvailableOtherQty,
            csComitted: committedCaseQty || 0,
            pcComitted: committedPieceQty || 0,
            otherComitted: committedOtherQty || 0,
          };
          return { ...row, availableStock };
        });
        setRows(updatedRows || []);
        return;
        }
      }

      const totalData = getOrderTotalRowData(data, tableHeaders ?? TableHeaders, ConfigDictionary);
      setTotalFooterValue(totalData);

      let dataArr: viewManageOrderRowsData[] = [];
      let taxAmount: number = cokenpFlatTaxAmountField.current ? data?.totalTaxAmount : 0;

      const orderUomCheckConfig = await getConfigData("catalogue_configuration", "orderUomCheck");
      const orderUomCheck = orderUomCheckConfig[0]?.configValue ?? "";
      isCounterSaleOrder.current = data?.extendedAttributes?.isCounterSaleOrder ?? false
      outletReferenceId.current = data?.extendedAttributes?.outletReferenceId ?? ""
      data?.orderDetails?.forEach((item: any, index: any) => {
        const {
          batchCode,
          batchId,
          price,
          casePrice,
          otherUnitPrice,
          pieceQuantity,
          caseQuantity,
          otherUnitQuantity,
          productInfo,
          creationTime,
          netAmount,
          initialAmount,
          extendedAttributes,
          type,
          discountValue,
          discountInfo,
          initialNormalizedQuantity,
          couponValue
        } = item;
        const discount = truncateToTwoDecimals((discountValue ?? 0) + (couponValue ?? 0));
        const finalAmount = netAmount ? truncateToTwoDecimals(netAmount) : "0";
        const actualAmount = initialAmount ? truncateToTwoDecimals(initialAmount) : "0";
        const skuDescription = productInfo?.skuDescription ?? "-";
        const formattedPrice = truncateToTwoDecimals(price ?? 0);
        const formattedCasePrice = truncateToTwoDecimals(casePrice ?? 0);
        const formattedOtherPrice = truncateToTwoDecimals(otherUnitPrice ?? 0);
        const id = `row-${index + 1}`;

        const freeItem: boolean = type === "freeItem" || (!insideManageInvoice && item?.initialNormalizedQuantity === 0)

        const taxInfo = extendedAttributes?.taxInfo;
        if(!freeItem && !cokenpFlatTaxAmountField.current) {
          taxInfo?.forEach((taxType: any) => (taxAmount += taxType?.taxAmount || 0));
        }

        const skuDiscountInfo = [
          { discountType: "Coupon", discountAmount: couponValue ?? 0 },
         { discountType: "Scheme", discountAmount: discountValue ?? 0 },
        ]
        
        // setting available stock of the product
        const skuStock = stocksData?.[batchCode+'-'+(type === "freeItem" ? "foc" : "normal")];

        const {
          availableCaseQty,
          availablePieceQty,
          availableOtherQty,
          actualAvailableCaseQty,
          actualAvailablePieceQty,
          actualAvailableOtherQty,
          committedCaseQty,
          committedPieceQty,
          committedOtherQty,
        } = skuStock || {};
        const availableStock = {
          cs: availableCaseQty || 0,
          pc: availablePieceQty || 0,
          other: availableOtherQty || 0,
          actualAvailableCaseQty,
          actualAvailablePieceQty,
          actualAvailableOtherQty,
          csComitted: committedCaseQty || 0,
          pcComitted: committedPieceQty || 0,
          otherComitted: committedOtherQty || 0,
        };

        const minimumOrderQuantity = extendedAttributes?.moqValue ?? extendedAttributes?.minOrderQty ?? 0;


        const status = data?.status?.toLocaleUpperCase();

        dataArr.push({
          id,
          batchCode,
          batchId,
          skuDescription,
          caseQuantity,
          pieceQuantity,
          otherUnitQuantity,
          casePrice: formattedCasePrice,
          price: formattedPrice,
          otherUnitPrice: formattedOtherPrice,
          actualAmount,
          discount,
          finalAmount,
          creationTime,
          availableStock,
          taxInfo,
          status,
          uom: orderUomCheck === "true" ? (products[batchCode]?.uom ?? "") : "all",
          otherUnitName: products[batchCode]?.otherUnitName,
          initialCaseQuantity: caseQuantity,
          initialOtherUnitQuantity: otherUnitQuantity,
          initialPieceQuantity: pieceQuantity,
          freeItem,
          caseToPieceQty: products[batchCode]?.caseToPieceQuantity ?? extendedAttributes?.["caseToPiece"] ?? 99999,
          otherToPieceQty: products[batchCode]?.otherUnitToPieceQuantity ?? 99999,
          initialNormalizedQuantity,
          skuDiscountInfo,
          actualCaseQuantity: caseQuantity,
          actualPieceQuantity: pieceQuantity,
          actualOtherUnitQuantity: otherUnitQuantity,
          minimumOrderQuantity: minimumOrderQuantity,
          discountInfo: discountInfo,
          taxAmountCokeNp: item?.extendedAttributes?.totalTaxAmount ?? 0
        });
      });

      const cancelledInvoice: boolean =
        data?.status?.toLowerCase() === "rejected" && data?.invoiceNumber ? true : false;
      const eInvoiced: boolean =
        data?.status?.toLowerCase() === "invoiced" &&
        (data?.eInvoice === "true" || data?.extendedAttributes?.IRNDtls);

      let eWayBilled: boolean = false;
      if(eInvoiced) {
        setRejectionReasons(Object.keys(cancelEInvoiceAndEWayBillRejectionReasons))
        const response = await checkIsEWayBilledApi(data?.invoiceNumber);
        eWayBilled = response?.data?.success === true;
      }

      const statusReason: string = data?.statusReason ?? ""

      const orderStatus = data?.status ?? ""
      await fetchOutletApprovalData(orderStatus)
      setOrderData({ ...data, taxAmount, cancelledInvoice, eInvoiced, eWayBilled, statusReason});
      const res=await populateCartDuringEditOrder({ ...data, taxAmount, cancelledInvoice, eInvoiced, eWayBilled, statusReason})
      if (res === "invalidPricing"){
        return;
      }
      if (batchIdConfiguration && insideManageInvoice) {
        const combinedRows = combineTableRowsWithStock(dataArr, stocksData, true);
        setRows(combinedRows);
        return;
      }
      
      setRows(dataArr);
    } catch (e) {
      console.error(e);
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching available stock data")
      );
    }
  };

  const fetchOutletApprovalData = async (orderStatus: string) => {
    try {
      const outletData = await getOutletApprovalData(outletReferenceId.current) ?? {};
      const feature = outletData?.data?.features?.[0] ?? {};
      setOutletApprovalData(feature);

      const outletApprovalStatus = feature?.status?.toUpperCase();
      
      cancelOrder.current = (outletApprovalStatus === "REJECTED" && orderStatus !== "REJECTED")
    

      if (isCounterSaleOrder.current && !allowUnapprovedOutlets.current){

        setIsOutletApproved(
          outletApprovalStatus?.length > 0 
            ? outletApprovalStatus.toLowerCase() === "approved"
            : false
        );
      }else{
        setIsOutletApproved(true)
      }
    } catch (error) {
      console.error("Failed to fetch outlet approval data:", error);
      isCounterSaleOrder.current ? setIsOutletApproved(false) : setIsOutletApproved(true)
    }
  };

  const getOrderDetails = async (orderId: string, TableHeaders?: Record<string, string>) => {
    try {
      let res, data;

      if (insideManageInvoice) {
        // Start a custom trace for view secondary order page load time
        const pageLoadTrace: PerformanceTrace = trace(performance, "view_secondary_order_invoice_page_load_time");
        pageLoadTrace.start();

        try {
          res = await getSalesData(orderId);
          if (res?.data?.features?.length == 0) throw new Error();
          data = {
            ...res?.data?.features?.[0],
            orderDetails: res?.data?.features?.[0]?.salesDetails,
          };
          const hasEdited = res?.data?.features?.[0]?.extendedAttributes?.invoiceEdited ?? false
          data?.orderDetails?.map((item: any) => {
            const { initialCaseQuantity, initialPieceQuantity, initialOtherUnitQuantity } =
              item || {};
            item.caseQuantity = initialCaseQuantity;
            item.pieceQuantity = initialPieceQuantity;
            item.otherUnitQuantity = initialOtherUnitQuantity;
          });
          const updatedOrderDetails = data?.orderDetails
            ?.filter((item: any) => {
              const { caseQuantity, pieceQuantity, otherUnitQuantity } = item || {};

              if (!(caseQuantity == 0 && pieceQuantity == 0 && otherUnitQuantity == 0)) return item;
            })
            ?.filter((item: any) => Boolean(item));

          data.orderDetails = updatedOrderDetails;
          setCanPushToEInvoice(
            data?.hasGstin &&
              data?.eInvoice != "true" &&
              !Boolean(data?.extendedAttributes?.IRNDtls)
          );
          setInvoiceExpired(( Boolean(ConfigDictionary?.invoiceEditedOnceCheck ?? false) && hasEdited) || (checkIfNHoursPassed(data?.creationTime, ConfigDictionary?.invoiceExpiryCheckValue ?? 72) && data?.status?.toLowerCase() == "invoiced" && Boolean(ConfigDictionary?.invoiceExpiryCheck)))

          logEvent(analytics, "secondary_invoice_details_viewed", {
            "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
            "invoice_id": data?.id ?? null,
            "invoice_value": data?.netAmount ?? null
          });
          } catch (e) {
          console.error(e);
          throw new Error();
        } finally {
          // Ensure that the trace always stops after the async operation
          pageLoadTrace.stop();
        }
      } else {
        // Start a custom trace for view secondary order page load time
        const pageLoadTrace: PerformanceTrace = trace(performance, "view_secondary_order__view_order_page_load_time");
        pageLoadTrace.start();

        try {
          res = await getSingleOrder(orderId);
          data = res?.data?.features?.[0];

          if(isEditing) {
            logEvent(analytics, "secondary_order_details_edit_open", {
              "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
              "order_id": data?.id ?? null,
              "order_value": data?.totalAmount ?? null,
            });
          } else {
            logEvent(analytics, "secondary_order_details_viewed", {
              "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
              "order_id": data?.id ?? null,
              "order_value": data?.totalAmount ?? null,
            });
          }
        } catch (e) {
          console.error(e);
          throw new Error();
        } finally {
          pageLoadTrace.stop();
        }
      }

      await setDataRowAndFooter(data ?? {}, [], TableHeaders);
    } catch (err) {
      console.error(err);
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `${insideManageInvoice ? `Invoice` : `Order`} with order-number : ${orderId} not found`
        )
      );
    } finally {
      setLoader(false);
    }
  };

  const fetchRequiredConfigs = async () => {
    try {
      const statusConfig = await getConfigData("order_configuration", "orderTrackingStages");
      const rejectionReasonsConfig = await getConfigData(
        "dms_configuration",
        "orderCancellationReasons"
      );

      const res = await getConfigData("dms_configuration", "hideAddMoreInEditOrder");
      const res2 = await getConfigData("dms_configuration", "disableEditInvoiceFlow");
      const res3 = await getConfigData("dms_configuration", "disableStockCheck");
      const res7 = await getConfigData("dms_configuration", "disableSchemeCheck");
      const res4 = await getConfigData("dms_configuration", "hideItemLevelTaxInfo");
      const res5 = await getConfigData("dms_configuration", "hideOrderProgressCard");
      const res8 = await getConfigData("dms_configuration", "disableorderedit");
      const res9 = await getConfigData("dms_configuration", "disableOrderStatusChange");
      const res11 = await getConfigData("dms_configuration", "useNewOrderStatusUpdateAPI");
      const res10 = await getConfigData("dms_configuration", "cokenpFlatTaxAmountField");

      const res12 = await getConfigData("dms_configuration", "disableOrderEditDesignationBased");
      const res13 = await getConfigData("dms_configuration", "disableCreateInvoiceDesignationBased");
      const res15 = await getConfigData("dms_configuration", "couponLabelConfig")
      const res17 = await getConfigData("dms_configuration", "hideAdditionalDistributorDiscount")
      const res18 = await getConfigData("dms_configuration", "allowUnapprovedOutlets");
      const res19 = await getConfigData("order_configuration", "orderConfirmationEnabled");
      const orderUomCheckConfig = await getConfigData("catalogue_configuration", "orderUomCheck");
      const res20 = await getConfigData("dms_configuration", "enableSKUReplacement");
      const res21 = await getConfigData("dms_configuration", "hideItemLevelDiscountInfo");
      const res22 = await getConfigData("dms_configuration", "hideCouponDiscount");
      const res23 = await getConfigData("dms_configuration", "viewOrderV2ColumnsConfiguration");
      orderUomCheck.current = orderUomCheckConfig[0]?.configValue ?? "";
      const enableRemainingStocksLabelConfig = await getConfigData("dms_configuration", "enableRemainingStocksLabel");
      enableRemainingStocksLabel.current = enableRemainingStocksLabelConfig[0]?.configValue ?? enableRemainingStocksLabel.current;
      enableSKUReplacement.current = res20[0]?.configValue ?? "";
      allowUnapprovedOutlets.current = res18[0]?.configValue ?? false;
      const viewQpsFocInSummaryConfig = await getConfigData(
              "dms_configuration",
              "viewQpsFocInSummary"
            );
      viewQpsFocInSummary.current = viewQpsFocInSummaryConfig?.[0]?.configValue ?? false;
      setDisableOrderEditDesignationBased(res12[0]?.configValue?.enable ?? false);
      setDisableCreateInvoiceDesignationBased(res13[0]?.configValue?.enable ?? false);
      setOrderEditAllowedRoles(res12[0]?.configValue?.rolesAllowedForOrderEdit ?? [])
      setCreateInvoiceDisableRoles(res13[0]?.configValue?.rolesNotAllowedForOrderEdit ?? [])
      const res16 = await getConfigData("dms_configuration", "enableMOQCheck");
      const invoiceReportConfig = await getConfigData("dms_configuration", "invoiceReportId")
      const invoiceReportName = invoiceReportConfig[0]?.configValue[0]?.reportName ?? ""
      const invoiceTaskName = invoiceReportConfig[0]?.configValue[0]?.taskName ?? ""
      setInvoiceReportName(invoiceReportName)
      setInvoiceTaskName(invoiceTaskName)
      const res6 = await getConfigData("order_configuration", "goToInvoiceRedirectionButton");
  
      disableSchemeCheck.current = res7[0]?.configValue ?? false;
      hideAddMoreInEditOrder.current = res[0]?.configValue ?? false;
      disableEditInvoiceFlow.current = res2[0]?.configValue ?? false;
      disableStockCheck.current = res3[0]?.configValue ?? false;
      hideItemLevelDiscountInfo.current = res21[0]?.configValue ?? false;
      hideCouponDiscount.current = res22[0]?.configValue ?? false

      const designation = JSON.parse(localStorage.authContext).user.designation || [];

      const enableMOQCheckConfig = res16[0]?.configValue;
  
      if (enableMOQCheckConfig?.enable) enableMOQCheck.current = isMOQEnabled(designation, enableMOQCheckConfig)

      hideAdditionalDistributorDiscount.current = res17[0]?.configValue ?? false;
      
      hideItemLevelTaxInfo.current = res4[0]?.configValue ?? false;
      cokenpFlatTaxAmountField.current = res10[0]?.configValue ?? false;
      hideOrderProgressCard.current = res5[0]?.configValue ?? false;
      showGoToInvoiceRedirectionButton.current = res6[0]?.configValue ?? false;
      disableOrderEdit.current = res8[0]?.configValue ?? false;
      disableOrderStatusChange.current = res9[0]?.configValue ?? false;
      useNewOrderStatusUpdateAPI.current = res11[0]?.configValue ?? false;
      couponLabel.current = res15[0]?.configValue ?? "Coupon Discount"
      setRejectionReasons(rejectionReasonsConfig?.[0]?.configValue ?? []);
      setOrderTrackingConfig(statusConfig[0]?.configValue ?? []);

      orderConfirmationEnabled.current = res19[0]?.configValue ?? true;
      columnsConfigurationRef.current = res23[0]?.configValue ?? undefined;
    } catch (e) {
      console.error("Error while fetching configs", e);
    }
  };


  const isUserNotAllowedToCreateInvoice = () => {
    const userDesignation = JSON.parse(localStorage.authContext)?.user?.designation || [];
    if (!Array.isArray(userDesignation)) {
      return false; 
    }
    return userDesignation.some(designation => createInvoiceDisableRoles.includes(designation));
  };

  useEffect(() => {
    const tableData = setAndGetViewOrderEditTableHeader(ConfigDictionary);
    SetViewOrderEditTableHeader(tableData);
  
    // Check if addMorePressedWhileEditing flag is set in sessionStorage
    const addMorePressedWhileEditing = sessionStorage.getItem("addMorePressedWhileEditing");
    if (orderId) {
      setLoader(true);
  
      // Chain the promises to ensure fetchRequiredConfigs runs first
      fetchRequiredConfigs()
        .then(() => getOrderDetails(orderId, tableData))
        .finally(() => {
          setLoader(false);
        });
    } else {
      navigate("/dashboard/sale/manageOrders", { replace: true });
      return;
    }
  }, [orderId, insideManageInvoice]);

  // Effect to automatically trigger edit button when data is loaded and conditions are met
  useEffect(() => {
    if (orderData && !loader && !isEditing && sessionStorage.getItem("addMorePressedWhileEditing") === "true") {
      const shouldEnableEdit = 
        (!orderData?.eInvoiced && 
         !invoiceExpired && 
         isOutletApproved && 
         !Boolean(disableOrderEdit.current) && 
         !insidePresellerLoadout) ||
        (disableOrderEditDesignationBased && 
         !insideManageInvoice && 
         isUserAllowedToEdit(orderEditAllowedRoles) && 
         !invoiceExpired && 
         isOutletApproved);
      
      if (shouldEnableEdit) {
        // Use setTimeout to ensure this runs after the component has fully rendered
        setTimeout(() => {
          handleEditClick();
        }, 1);
      }

      sessionStorage.removeItem("addMorePressedWhileEditing")
    }
  }, [orderData, loader, isEditing]);

  const handleSaveQuantityChanges = async () => {
    const validOrderData = JSON.parse(JSON.stringify(orderData));
    const validOrderDetails = validOrderData?.orderDetails?.filter(
      (sku: any) => sku?.type !== `freeItem`
    );
    validOrderData.orderDetails = validOrderDetails;
    if (batchIdConfiguration && insideManageInvoice){
      validOrderData.orderDetails = combineTableRowsForCSO(validOrderDetails);
    }

    const modifiedCart: any = await modifyCartToValidate(setCart, validOrderData);

    let editedSkus: string[] = [];
    let editedCQ: number = 0;
    let editedPQ: number = 0;
    let editedOUQ: number = 0;

    for (const row of rows) {
      if (
        (row?.actualCaseQuantity !== row?.caseQuantity) ||
        (row?.actualPieceQuantity !== row?.pieceQuantity) ||
        (row?.actualOtherUnitQuantity !== row?.otherUnitQuantity)
      ) {
        // Accumulate the edited quantities if changes are detected
        if (row?.actualCaseQuantity !== row?.caseQuantity) {
          editedCQ += row?.actualCaseQuantity - row?.caseQuantity;
        }

        if (row?.actualPieceQuantity !== row?.pieceQuantity) {
          editedPQ += row?.actualPieceQuantity - row?.pieceQuantity;
        }

        if (row?.actualOtherUnitQuantity !== row?.otherUnitQuantity) {
          editedOUQ += row?.actualOtherUnitQuantity - row?.otherUnitQuantity;
        }

        if((editedCQ !== 0) || (editedPQ !== 0) || (editedOUQ !==0)) {
          editedSkus.push(row?.batchCode);
        }
      }
    }
    const isCounterSaleOrder = validOrderData?.extendedAttributes?.isCounterSaleOrder ?? false
    const outletReferenceId = validOrderData?.extendedAttributes?.outletReferenceId ?? ""
    try {
      setOrderStatusChangeLoading("SAVE_CHANGES");
      const requestBody: Record<any, any> | null = getValidateRequestBody(
        modifiedCart?.[validOrderData?.outletCode],
        validOrderData, 
        true,
        isCounterSaleOrder,
        outletReferenceId,
      );

      if (insideManageInvoice && requestBody) {
        requestBody["salesDetails"] = requestBody?.["orderDetails"];
        requestBody["invoiceNumber"] = validOrderData?.invoiceNumber;
        requestBody["extendedAttributes"] = {...requestBody["extendedAttributes"], invoiceEdited: true}

        delete requestBody?.["orderDetails"];
        delete requestBody?.["finalOrderInfo"];
        delete requestBody?.["referenceNumber"];

        let resp = await updateInvoice(requestBody);
        let updatedInvoice = resp?.data?.feature[0];

        let prevBatchCodes : string[] = orderData?.orderDetails?.map((s: any) => s?.batchCode) ?? [];
        let newBatchCodes : string[] = updatedInvoice?.orderDetails?.map((s: any) => s?.batchCode) ?? [];
        let uniqueNewBatchCodes = newBatchCodes?.filter(code => !prevBatchCodes?.includes(code)).join(",");
        let uniqueNewBatchCodesNormalizedQuantity = updatedInvoice?.salesDetails
          ?.filter((s: any) => uniqueNewBatchCodes?.includes(s?.batchCode))
          ?.reduce((sum: number, s: any) => sum + (s?.normalizedQuantity || 0), 0);

        logEvent(analytics, "secondary_invoice_edited", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "invoice_id": orderData?.id ?? null,
          "edited_skus": editedSkus.join(","),
          "edited_qty": formatEditedQuantities(editedCQ, editedPQ, editedOUQ),
          "total_discount": updatedInvoice?.discountInfo?.[0]?.discount ?? null,
          "added_skus": uniqueNewBatchCodes ?? null,
          "added_qty": uniqueNewBatchCodesNormalizedQuantity ?? null,
        });
      } else {
        const response = await ChannelkartNetworkPost(
          "/orders/validate?transformerOut=orderDetailSplit",
          requestBody
        );
        if (response?.status === 200 || response?.status === 201) {
          const validateResponse = response?.data?.feature?.[0];
          delete validateResponse["creationTime"];
          const orderPutPayload = prepareEditOrderReqBody(validateResponse, validRows);
          await updateOrder(orderPutPayload, validOrderData?.orderNumber);

          let prevBatchCodes : string[] = orderData?.orderDetails?.map((s: any) => s?.batchCode).collect ?? [];
          let newBatchCodes : string[] = validateResponse?.orderDetails?.map((s: any) => s?.batchCode).collect ?? [];
          let uniqueNewBatchCodes = newBatchCodes?.filter(code => !prevBatchCodes?.includes(code)).join(",");
          let uniqueNewBatchCodesNormalizedQuantity = validateResponse?.orderDetails
            ?.filter((s: any) => uniqueNewBatchCodes?.includes(s?.batchCode))
            ?.reduce((sum: number, s: any) => sum + (s?.normalizedQuantity || 0), 0);

            logEvent(analytics, "secondary_order_edited", {
                "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
                "order_id": orderData?.id ?? null,
                "edited_skus": editedSkus?.join(",") ?? "", // Join editedSkus array if exists, fallback to empty string if undefined
                "edited_qty": formatEditedQuantities(editedCQ, editedPQ, editedOUQ) ?? 0, // Ensure a fallback value of 0 if function returns undefined
                "total_discount": validateResponse?.discountInfo?.[0]?.discount ?? null, // Safely access discount or fallback to null
                "added_skus": uniqueNewBatchCodes ?? [], // Default to an empty array if uniqueNewBatchCodes is undefined
                "added_qty": uniqueNewBatchCodesNormalizedQuantity ?? 0, // Default to 0 if uniqueNewBatchCodesNormalizedQuantity is undefined
              });

        }
      }

      resetGenericModalProps();
      refresh();
    } catch (e) {
      console.error(e);
      setGenericModalProps(getGenericModalProps("error", `Error while saving the changes`));
    } finally {
      setOrderStatusChangeLoading("");
    }
  };

  const refresh = () => {
    setLoader(true);
    Promise.allSettled([
      getOrderDetails(insideManageInvoice ? orderData?.orderNumber : orderData?.id),
    ]).finally(() => {
      setLoader(false);
    });
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleModalOpen = async () => {
    if (disableActionButtons) return;
    if (openInvalidOrderModal()) return;

    if (orderData?.status?.toLocaleUpperCase() === "PENDING") {
      if (openingInvoiceModalRef.current) return;
      openingInvoiceModalRef.current = true
      setOpeningInvoiceModalState(true)
      try {
        const batchCodes: string[] = orderData.orderDetails
          .filter((item: any) => item.type !== "freeItem" && item.batchCode)
          .map((item: any) => item.batchCode);
        
        let skuToReplacementSkuMap: Record<string, string[]> = {};
        let replacementSkuList: string[] = [];

        if (enableSKUReplacement.current){
          ({ skuToReplacementSkuMap, replacementSkuList } = await getSkuToReplacementSkuMap(batchCodes));
        }
        // Step 2: merge sku list
        const mergedSkuList = Array.from(
          new Set([...batchCodes, ...replacementSkuList])
        ).join(",");

        const BATCH_SIZE = 100;
        const allBatchCodesArray = mergedSkuList
          .split(",")
          .map((code) => code.trim())
          .filter(Boolean);

        let stocksData: any[] = [];
        for (let i = 0; i < allBatchCodesArray.length; i += BATCH_SIZE) {
          const chunk = allBatchCodesArray.slice(i, i + BATCH_SIZE).join(",");
          const chunkStockData = await fetchBatchDataForSkuList(
            chunk,
            getQuantityType()
          );
          stocksData = stocksData.concat(chunkStockData);
        }

        //map of skucode to smallest expiryDate among all batches
        let skuToMinExpiryDate: Record<string, Date> = {}

        skuToMinExpiryDate = getSkuToMinExpiryDate(stocksData);

        //sort the map based on expiry time. FEFO
        if (skuToReplacementSkuMap) {
          Object.keys(skuToReplacementSkuMap).forEach((sku) => {
            skuToReplacementSkuMap[sku].sort((a, b) => {
              const dateA = skuToMinExpiryDate[a]?.getTime() ?? Infinity;
              const dateB = skuToMinExpiryDate[b]?.getTime() ?? Infinity;
              return dateA - dateB;
            });
          });
        }
       
        let stocksDataResult = await createSkuWiseStockMapForBatchId(stocksData);
        let stockBatchWiseMap = getBatchCodeQuantities(
          mergedSkuList,
          stocksDataResult
        );

        const ConfigDictionary = JSON.parse(
          localStorage.getItem("ConfigDictionary") ?? "{}"
        );
        const { uomConversion } = ConfigDictionary;

        const pricingData = await createCatalogue(
          OrderType.SECONDARY,
          orderData?.outletCode,
          !disableSchemeCheck.current,
          allBatchCodesArray,
          fetchPricingBySalesrep ? orderData?.loginId : undefined,
          undefined,
          undefined,
          orderData?.supplier,
          true
        );

        const dbResult = await getDataFromLocalDb("Catalogue");
        const products: any = dbResult.data;

        // First, let's calculate normalized quantities for the stockBatchWiseMap
        const normalizedStockMap = new Map<string, number>();

        // Preprocess the stock data to include normalized quantities
        if (uomConversion) {
          // Convert Map entries to array for compatibility with older ES versions
          const stockBatchWiseEntries: Array<[string, [number, number, number]]> =
            [];
          stockBatchWiseMap.forEach((value, key) => {
            stockBatchWiseEntries.push([key, value]);
          });

          for (let i = 0; i < stockBatchWiseEntries.length; i++) {
            const [batchCode, quantities] = stockBatchWiseEntries[i];
            const product = createCartProductFromCatalogue(products, batchCode);
            if (product) {
              const [avCs, avPi, avOth] = quantities;
              // Calculate normalized quantity based on product conversion factors
              const stockNormalizedQty =
                avCs * (product?.case2Piece ?? 0) +
                avOth * (product?.otherUnit2Piece ?? 0) +
                avPi;

              // Store the normalized quantity for this batch code
              normalizedStockMap.set(batchCode, stockNormalizedQty);
            }
          }
        }

        // Clone the normalizedStockMap
        const tempNormalizedStockMap = new Map<string, number>()
        normalizedStockMap.forEach((value, key) => {
          tempNormalizedStockMap.set(key, value)
        })

        const stockExceedingSkuMap = new Map<string, number>()
        const finalSkuMap = new Map<string, number>()

        // Check availability for all items in this order
        for (const roo of orderData.orderDetails) {
          const caseOQ = roo?.caseQuantity ?? 0
          const pieceOQ = roo?.pieceQuantity ?? 0
          const otherUnitOQ = roo?.otherUnitQuantity ?? 0
          const batchCode = roo?.batchCode ?? ""

          const product = createCartProductFromCatalogue(products, batchCode);

          if (uomConversion && product) {
            // Calculate normalized order quantity
            const orderDetailsNQ =
              caseOQ * (product?.case2Piece ?? 0) +
                otherUnitOQ * (product?.otherUnit2Piece ?? 0) +
                pieceOQ

            // Normalized stock quantity
            const stockNQ = tempNormalizedStockMap.get(batchCode) ?? 0

            if (orderDetailsNQ <= stockNQ) {
              finalSkuMap.set(product.batchCode, orderDetailsNQ)
              tempNormalizedStockMap.set(batchCode, stockNQ - orderDetailsNQ)
            } else {
              finalSkuMap.set(product.batchCode, stockNQ)
              stockExceedingSkuMap.set(product.batchCode, orderDetailsNQ - stockNQ)
              tempNormalizedStockMap.set(batchCode, 0)
            }
          }
        }

        let newReplacementSkuMap = new Map<string, number>();

        if (!enableSKUReplacement.current){
          let totalFulfilled = 0;
          finalSkuMap.forEach((qty, sku) => {
            totalFulfilled += qty;
          });

          if (totalFulfilled === 0) {
            willGetRejected.current = true;
          }

          // 3️⃣ If some SKUs could not be fulfilled, mark partial invoice (before replacements)
          if (stockExceedingSkuMap.size !== 0) {
            willOrderGetPartiallyInvoiced.current = true;
          }
        }

        if (stockExceedingSkuMap.size !== 0 && enableSKUReplacement.current) {
          const result = processSkuFulfillment(
            finalSkuMap,
            stockExceedingSkuMap,
            skuToReplacementSkuMap,
            tempNormalizedStockMap,
            products
          );
          originalSkuFulfillmentMapRef.current = result.originalSkuFulfillmentMap;
          
          
          let totalFulfilledAfterReplacement = 0
          originalSkuFulfillmentMapRef.current.forEach((info) => {
            totalFulfilledAfterReplacement += info.selfQty;
            info.replacements.forEach((repQty) => {
              totalFulfilledAfterReplacement += repQty;
            });
          });

          if (totalFulfilledAfterReplacement === 0) {
            willGetRejected.current=true
          }
          let hasReplacements = false;
          originalSkuFulfillmentMapRef.current.forEach((info) => {
            if (info.replacements.size > 0) {
              hasReplacements = true;
            }
          });
          if (result.hasUnfulfilled) {
            willOrderGetPartiallyInvoiced.current =  true;
          } else {
            willOrderGetPartiallyInvoiced.current =  false;
          }

          skuNameMap.current = result.skuNameMap;
          newReplacementSkuMap = result.newReplacementSkuMap;
          performSkuReplacement.current = hasReplacements;
        }

        if (performSkuReplacement.current){
          const uomWiseAllocationMap = new Map<
            string,
            { caseQty: number; pieceQty: number; otherUnitQty: number }
          >()
          const addToUomWiseAllocation = (sku: string, normalizedQty: number) => {
            const product = createCartProductFromCatalogue(products, sku);
            if (!product) return
            if (normalizedQty === 0) return
            let {
              batchCode,
              case2Piece,
              otherUnit2Piece,
              uom,
              otherUnitName,
            } = product
            if (orderUomCheck.current === "true") {
              uom = products[batchCode]?.uom ?? ""
            } else {
              uom = "all"
            }
            // Call performUomConversion → pass normalizedQty as pieceQty, caseQty & otherQty = 0
            const { convertedCaseQty, convertedOtherQty, convertedPieceQty } =
              performUomConversion(
                0,
                0,
                normalizedQty,
                uom,
                case2Piece,
                otherUnit2Piece,
                0,
                0,
                0,
                true,
                otherUnitName
              )

            const existing = uomWiseAllocationMap.get(sku) ?? {
              caseQty: 0,
              otherUnitQty: 0,
              pieceQty: 0,
            }

            uomWiseAllocationMap.set(sku, {
              caseQty: existing.caseQty + convertedCaseQty,
              otherUnitQty: existing.otherUnitQty + convertedOtherQty,
              pieceQty: existing.pieceQty + convertedPieceQty,
            })
          }

          finalSkuMap.forEach((qty, sku) => {
            addToUomWiseAllocation(sku, qty)
          })

          newReplacementSkuMap.forEach((qty, sku) => {
            addToUomWiseAllocation(sku, qty)
          })

          const orderSummary = getOrderSummaryFromAllocation(
            uomWiseAllocationMap,
            products
          );

          const isCounterSaleOrder =
            orderData?.extendedAttributes?.isCounterSaleOrder ?? false;
          const outletReferenceId =
            orderData?.extendedAttributes?.outletReferenceId ?? "";

          const replacementValidateResponse = getValidateBodyForSKUReplacement(
            orderData,
            orderSummary,
            isCounterSaleOrder,
            outletReferenceId
          );

          const response = await ChannelkartNetworkPost(
            "/orders/validate?transformerOut=orderDetailSplit",
            replacementValidateResponse
          );
          newOrderDataAfterReplacement.current = response.data.feature[0];
        }
        setModalOpen(true);
      } catch (error) {
        console.error("Error in handleModalOpen:", error);
        setGenericModalProps(
          getGenericModalProps("error", "Something went wrong")
        )
      } finally {
        
        openingInvoiceModalRef.current = false
        setOpeningInvoiceModalState(false)
      }
    } else {
      setModalOpen(true);
    }

  };

  const openInvalidOrderModal = () => {
    if (!orderData?.orderNumber && !orderData?.id) {
      setGenericModalProps(getGenericModalProps("error", `Invalid order, cannot proceed`));
      return true;
    } else {
      return false;
    }
  };

const hasRealChanges = () => {
  // Deep clone to avoid mutating
  const validOrderData = JSON.parse(JSON.stringify(orderData));

  // Filter free items from orderData
  const validOrderDetails: any = validOrderData?.orderDetails?.filter(
    (sku: any) => sku?.type !== "freeItem"
  );

  // Filter free items from rows
  const validRows = rows.filter((row: any) => !row?.freeItem);

  if (batchIdConfiguration && insideManageInvoice) {
    const uniqueValidOrderDetails = Array.from(
      new Set(validOrderDetails.map((item: any) => item?.batchCode))
    );

    if (uniqueValidOrderDetails.length !== validRows.length) return true;
  } else {
    if (validOrderDetails.length !== validRows.length) return true;
  }

  // Check quantities
  for (const row of validRows) {
    if (
      row?.actualCaseQuantity !== row?.caseQuantity ||
      row?.actualPieceQuantity !== row?.pieceQuantity ||
      row?.actualOtherUnitQuantity !== row?.otherUnitQuantity
    ) {
      return true;
    }
  }

  return false;
};


  const handleClickAddMore = async () => {
    if (openInvalidOrderModal()) return;

    if(isEditing) {
      sessionStorage.setItem("addMorePressedWhileEditing", "true");
    }
    const state = (insideManageInvoice && batchIdConfiguration)
      ? { batchIdCatalogue: batchIdConfiguration, isEditing, aggregateStockSummaryMap, isPartialOrder, isBulkPanel}
      : {aggregateStockSummaryMap, isPartialOrder, isBulkPanel};

    // Check if we're in editing mode and there are real changes
    if (isEditing && hasRealChanges()) {
      // Check what the leftBtnText would be in the save changes modal
      const wouldShowYes = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current));
      
      if (wouldShowYes) {
        // If "Yes" would be shown, directly execute the save changes function
        await handleSaveQuantityChanges();
        
        // Then navigate as usual
        navigate(
          `/dashboard/sale/manageOrders/addMore/${
            insideManageInvoice ? orderData?.orderNumber : orderData?.id
          }?outletId=${orderData?.outletCode}${insideManageInvoice ? `&invoice=true` : ``}`,
          state ? {state} : undefined
        );
      } else {
        // If "Edit Order" would be shown, show the modal
        await handleClickSaveChanges();
      }
      return;
    }

    navigate(
      `/dashboard/sale/manageOrders/addMore/${
        insideManageInvoice ? orderData?.orderNumber : orderData?.id
      }?outletId=${orderData?.outletCode}${insideManageInvoice ? `&invoice=true` : ``}`,
      state ? {state} : undefined
      );
  };

    const handleClickSaveChanges = async () => {
    if (openInvalidOrderModal()) return;

    setSaveChangesLoading(true);
    const isEmptyTable = checkForEmptyTable(validRows);
    if (!isEmptyTable) await setDataRowAndFooter(orderData, rows);
    setSaveChangesLoading(false);

    let message = ""

    const affectedBatchCodes = checkAllRowsToRemove(validRows, isEditing, enableMOQCheck.current, disableStockCheck.current);

    if (affectedBatchCodes !== false){
      message = `Minimum Billable Quantity is larger than the available stock for the following SKU(s): ${affectedBatchCodes.join(", ")}. Order cannot be placed for these SKU(s).`;
    }
    else{

      message = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current))
        ? `Are you sure you want to save the changes made? ${
            isEmptyTable ? "Disclaimer: your order will be rejected." : ""
          }`
        : 
        (!checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current)) 
        ?
        `Ordered quantity is more than the Available stock. Please adjust the quantity before saving.`
        :
        `Ordered quantity is less than the Minimum Billable Quantity. Please adjust the quantity before saving.`
    }

    const leftBtnFn =
    ((!validRows?.length || isEmptyTable) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current))
      ? () => logLoadTrace(() => handleOrderStatusChange(insideManageInvoice ? "CANCELLED" : "REJECTED"), insideManageInvoice ? "secondary_order_reject_invoice_time" : "secondary_order_reject_order_time")
      : (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current))
      ? () => handleSaveQuantityChanges()
      : () => resetGenericModalProps();

    const rightBtnFn = async () => {
      (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current)) ? resetGenericModalProps() : handleDisableEditing();
    };

    const leftBtnText = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current)) ? "Confirm" : "Edit Order";
    const rightBtnText = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current)) ? "Go Back" : "Close";

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      leftBtnText,
      rightBtnText,
      leftBtnFn,
      rightBtnFn,
      undefined,
      undefined,
      undefined,
      undefined,
      '455px'
    );
    setGenericModalProps(updatedGenericModalProps);
  };


   const handleCancel = async () => {
    setEditLoading(true);
    await handleReset();
    setIsEditing(false);
    setEditLoading(false);
  };

 const handleClickPushToEInvoice = () => {
    if (openInvalidOrderModal()) return;

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      "Are you sure you want to push to e-invoice",
      "Yes",
      "No",
      () => logLoadTrace(handlePushToEInvoice,"secondary_order_push_to_einvoice_time"),
      resetGenericModalProps
    );
    setGenericModalProps(updatedGenericModalProps);
  };

  const handleClickGenerateEWayBill = () => {
    if (openInvalidOrderModal()) return;

    setEWayBillModalState({...eWayBillModalInitialState, open: true});
  };

useEffect(() => {
  const shortcutConfig: {
    [key: string]: {
      action: () => void | Promise<void>;
      condition?: () => boolean;
      requiresShift?: boolean;
    };
  } = {
    k: {
      action: handleClickAddMore,
      condition: () => {
        const status = orderData?.status?.toLowerCase();
        const allowedStatuses = ["pending", "confirmed", "partially confirmed"];
        if (
          isEditing ||
          !allowedStatuses.includes(status) ||
          invoiceExpired ||
          orderData?.eInvoiced  || !isOutletApproved
        ) {
          console.log('Shortcut "k" condition failed:', {
            isEditing,
            status,
            hideAddMoreInEditOrder: hideAddMoreInEditOrder.current,
            invoiceExpired,
            eInvoiced: orderData?.eInvoiced,
          });
          return false;
        }
        const isAllowedByDesignation = !disableOrderEditDesignationBased || isUserAllowedToEdit(orderEditAllowedRoles);
        return isAllowedByDesignation;
      },
    },
    e: {
      action: async () => {
        if (editLoading) return;
        if (openInvalidOrderModal()) return;
        setEditLoading(true);
        await setDataRowAndFooter(orderData, rows);
        setSnackbarOpen(true);
        setEditLoading(false);
        setIsEditing(true);
      },
      condition: () => {
        if (isEditing || !isOutletApproved) return false;
        if (
          orderData?.eInvoiced ||
          invoiceExpired ||
          !isOutletApproved ||
          disableOrderEdit.current
        )
          return false;
        const isAllowedByDesignation = !disableOrderEditDesignationBased || isUserAllowedToEdit(orderEditAllowedRoles);
        return isAllowedByDesignation;
      },
    },
    a: {
      action: () => {
        if (document.querySelector('[role="dialog"]')) return;

        if (orderCancelModalOpen) {
          if(!selectedRejectionReason) return;
          logLoadTrace(
            () => handleOrderStatusChange(
              insideManageInvoice ? "CANCELLED" : getOrderCancellationStatusId()
            ),
            insideManageInvoice
              ? "secondary_order_reject_invoice_time"
              : "secondary_order_reject_order_time"
          );
          return;
        }

        if(!orderConfirmationEnabled.current) {
          handleModalOpen()
          return;
        }

        // Handle "Go To Invoice" button
        if (
          showGoToInvoiceRedirectionButton.current &&
          orderData?.status?.toLowerCase() === "invoiced" &&
          !isEditing &&
          !insideManageInvoice
        ) {
          logLoadTrace(
            () => navigate(`/dashboard/sale/manageInvoices/viewInvoice/${orderData?.orderNumber ?? ""}`),
            "secondary_order_go_to_invoice_time"
          );
          return;
        }

        // Handle "Push to e-Invoice" button
        if (
          canPushToEInvoice &&
          !orderData?.eInvoiced &&
          !buttonLoading(orderStatusChangeLoading, "E_INVOICE")
        ) {
          handleClickPushToEInvoice();
          return;
        }

        // Handle "Generate e-way bill" button
        if (
          orderData?.eInvoiced &&
          !orderData?.eWayBilled &&
          !buttonLoading(orderStatusChangeLoading, "E_WAY_BILL")
        ) {
          logLoadTrace(handleClickGenerateEWayBill, "secondary_order_generate_eway_bill_time");
          return;
        }

        // Existing behavior for saving changes or confirming order
        if (isEditing) {
          handleClickSaveChanges();
        } else {
          const status = orderData?.status?.toLowerCase();
          if (status === "pending") {
            handleClickAccept();
          } else if (status === "confirmed" || status === "partially confirmed") {
            handleModalOpen();
          }
        }
      },
      condition: () => {
        if (document.querySelector('[role="dialog"]') || !isOutletApproved) return false;

        // Condition for "Go To Invoice" button
        if (
          showGoToInvoiceRedirectionButton.current &&
          orderData?.status?.toLowerCase() === "invoiced" &&
          !isEditing &&
          !insideManageInvoice
        ) {
          return true;
        }

        // Condition for "Push to e-Invoice" button
        if (
          canPushToEInvoice &&
          !orderData?.eInvoiced &&
          !buttonLoading(orderStatusChangeLoading, "E_INVOICE")
        ) {
          return true;
        }

        // Condition for "Generate e-way bill" button
        if (
          orderData?.eInvoiced &&
          !orderData?.eWayBilled &&
          !buttonLoading(orderStatusChangeLoading, "E_WAY_BILL")
        ) {
          return true;
        }

        // Existing conditions for other actions
        if (isEditing) {
          return true;
        }
        const status = orderData?.status?.toLowerCase();
        if (status === "pending") {
          return !disableOrderStatusChange.current;
        } else if (status === "confirmed" || status === "partially confirmed") {
          return !isUserNotAllowedToCreateInvoice();
        }
        return false;
      },
    },
    x: {
      action: () => {
        if (isEditing) {
          handleCancel();
        } else {
          setOrderCancelModalOpen(true);
        }
      },
      condition: () => {
        if (document.querySelector('[role="dialog"]')  || !isOutletApproved) return false;
        if (isEditing) {
          return true;
        }
        const status = orderData?.status?.toLowerCase();
        const isInvoiceCancellable = insideManageInvoice && status === "invoiced";
        const isOrderCancellable =
          !insideManageInvoice &&
          ["pending", "confirmed", "partially confirmed"].includes(status);
        const isPendingStatusAllowed = status === "pending" ? !disableOrderStatusChange.current : true;
        return (isInvoiceCancellable || isOrderCancellable) && isPendingStatusAllowed;
      },
    },
    z: {
      action: async () => {
                      if (editLoading) return;
                      setEditLoading(true);
                      await handleReset();
                      setEditLoading(false);
                    },
      condition: () => {
        if (!isEditing || document.querySelector('[role="dialog"]')) return false;
        return true;
      },
    },
    p: {
      action: () => {
        if (invoiceTaskName === "report") {
          logLoadTrace(downloadReportTaskPdf, "secondary_print_invoice_download_time");
        } else {
          logLoadTrace(() => handlePrintInvoice(false), "secondary_print_invoice_download_time");
        }
      },
      condition: () => {
        if (!orderData?.invoiceNumber) return false;
        const status = orderData?.status?.toLowerCase();
        const isPrintableStatus = [
          "invoiced",
          "delivered",
          "partial delivered",
          "out for delivery",
        ].includes(status);
        const isVisibleInInvoiceView = insideManageInvoice && !isEditing;
        const isVisibleInOrderView = disableEditInvoiceFlow.current && isPrintableStatus;
        return isVisibleInInvoiceView || isVisibleInOrderView;
      },
    },
    "shift+p": {
      action: () => {
        logLoadTrace(() => handlePrintInvoice(true), "secondary_view_invoice_time");
      },
      condition: () => {
        if (!orderData?.invoiceNumber) return false;
        const status = orderData?.status?.toLowerCase();
        return insideManageInvoice && !isEditing && status === "invoiced" && !buttonLoading(orderStatusChangeLoading, "VIEW_INVOICE");
      },
      requiresShift: true,
    },
  };

  const handleKeyDown = (event: KeyboardEvent) => {

    if (!event.ctrlKey && !event.metaKey) {
      return;
    }

    const key = event.key.toLowerCase();
    const isShiftPressed = event.shiftKey;
    const shortcutKey = isShiftPressed ? `shift+${key}` : key;
    const shortcut = shortcutConfig[shortcutKey];

    if (shortcut) {
      if (shortcut.requiresShift && !isShiftPressed) {
        console.log(`Shortcut "${shortcutKey}" requires Shift key but Shift is not pressed`);
        return;
      }
      if (!shortcut.requiresShift && isShiftPressed) {
        console.log(`Shortcut "${shortcutKey}" does not require Shift key but Shift is pressed`);
        return;
      }

      event.preventDefault();

      if (shortcut.condition && !shortcut.condition()) {
        console.log(`Shortcut "${shortcutKey}" condition not met`);
        return;
      }

      console.log(`Executing shortcut "${shortcutKey}" action`);
      shortcut.action();
    }
  };

  window.addEventListener("keydown", handleKeyDown);
  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [
  orderData,
  insideManageInvoice,
  invoiceTaskName,
  isEditing,
  invoiceExpired,
  disableOrderEditDesignationBased,
  orderEditAllowedRoles,
  createInvoiceDisableRoles,
  handleClickAddMore,
  handleModalOpen,
  handleClickAccept,
  handleClickSaveChanges,
  handleCancel,
  isUserAllowedToEdit,
  isUserNotAllowedToCreateInvoice,
  editLoading,
  isOutletApproved,
  disableOrderEdit,
  disableOrderStatusChange,
  setDataRowAndFooter,
  rows,
  populateCartDuringEditOrder,
  setSnackbarOpen,
  setIsEditing,
  setEditLoading,
  openInvalidOrderModal,
  setOrderCancelModalOpen,
  orderStatusChangeLoading,
  canPushToEInvoice,
  handleClickPushToEInvoice,
  handleClickGenerateEWayBill,
  showGoToInvoiceRedirectionButton, // Add dependency for Go To Invoice button
  navigate, // Add navigate to dependencies
]);

  const handleDisableEditing = () => {
    handleReset();
    resetGenericModalProps();
  };

  const resetGenericModalProps = () => setGenericModalProps(initialGenericModalProps);
  
  const handleEditClick = async () => {
    if (isEditing) return;
    if (!canEditOrder()) return;
    if (openInvalidOrderModal()) return;
    setSnackbarOpen(true);
    setIsEditing(true);
  };

  async function handleClickAccept ()  {
    if (openInvalidOrderModal()) return;

    await setDataRowAndFooter(orderData, rows);

    let message = ""
    
    const affectedBatchCodes = checkAllRowsToRemove(validRows, isEditing, enableMOQCheck.current, disableStockCheck.current);
    if (affectedBatchCodes !== false){
      message = `Minimum Billable Quantity is larger than the available stock for the following SKU(s): ${affectedBatchCodes.join(", ")}. Order cannot be placed for these SKU(s). Please Edit the order.`;
    }
    else{
      message = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current))
        ? `Are you sure you want to Confirm the order?`
        : 
        (!checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current)) 
        ?
        `Ordered quantity is more than the Available stock. Please edit the order to proceed.`
        :
        `Ordered quantity is less than the Minimum Billable Quantity. Please edit the order to proceed.`
    }

    const fn = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current))
      ? () => logLoadTrace(() => handleOrderStatusChange("CONFIRMED"), "secondary_order_confirm_order_time")
      : () => {
          setIsEditing(true);
          resetGenericModalProps();
        };

    const leftBtnText = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current)) ? "Yes" : "Edit";
    const rightBtnText = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) && checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current)) ? "No" : "";

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      leftBtnText,
      rightBtnText,
      fn,
      resetGenericModalProps
    );
    setGenericModalProps(updatedGenericModalProps);
  };

 

 

  const showStockExceedWarning = () => {
    const orderStatus = orderData?.status?.toUpperCase();

    return (
      (!checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) &&
      (ordersWithStockExceedingWarning?.includes(orderStatus) || insideManageInvoice)) && !disableStockCheck.current
    );
  };

  const showMOQWarning = () => {
    const orderStatus = orderData?.status?.toUpperCase();
    return (
      (!checkAllRowsHaveValidMOQ(validRows, isEditing, enableMOQCheck.current) &&
      (ordersWithStockExceedingWarning?.includes(orderStatus) || insideManageInvoice)) && enableMOQCheck.current
    );
  }

  const setOrResetCartDbData = async (setData: boolean = false) => {
    if (setData) {
      const res = await getDataFromLocalDb("Cart");
      const initialCart = await JSON.parse(JSON.stringify(res?.data?.[0]?.data ?? {}));

      cartDbInitialData.current = initialCart ?? {};

      return;
    } else {
      insertDataIntoLocalDB("Cart", [{ id: 1, data: cartDbInitialData.current }]);
    }
  };

  const handleReasonChange = (reason: string) => {
    setSelectedRejectionReason(reason);
  };

  const handleReasonStringChange = (reason: string) => {
    setRejectionReasonString(reason);
  };

  // to set and reset cart data in db
  useEffect(() => {
    setOrResetCartDbData(true);
    return () => {
      setOrResetCartDbData();
    };
  }, []);

  useEffect(() => {
    if (!rows.length || !orderData) return;
    setDisableActionButtons(hasRealChanges());
  }, [rows, orderData]);

  const viewOrderConfig = getViewOrderConfigV2(
        handleQuantityChange,
        handleOnBlur,
        handleRemove,
        handlePromotionModalVisibility,
        insideManageInvoice,
        TableHeaders,
        disableStockCheck.current,
        hideItemLevelTaxInfo.current,
        false,
        enableMOQCheck.current,
        isEditing,
        setIsEditing,
        updateQuantityAndBlur,
        handleEditClick,
        canEditOrder(),

        cokenpFlatTaxAmountField.current,
        isPartialOrder,
        enableRemainingStocksLabel.current,
        hideItemLevelDiscountInfo.current,
        columnsConfigurationRef.current
      );

  const viewOrderExpandableRows = getViewOrderExpandableRowsConfig(
    handleQuantityChange,
    handleOnBlur,
    handleRemove,
    handlePromotionModalVisibility,
    insideManageInvoice,
    TableHeaders,
    disableStockCheck.current,
    hideItemLevelTaxInfo.current,
    false,
    enableMOQCheck.current,
    isEditing,
    setIsEditing,
    updateQuantityAndBlur,
    handleEditClick,
    canEditOrder(),
  )

  const columns: any[] = viewOrderConfig?.columns;
  const expandableRowColumns: any[] = viewOrderExpandableRows?.columns
  const showOverlay: boolean =
    showOverlayIn?.includes(orderStatusChangeLoading) || editLoading || saveChangesLoading;

  const sortInvalidRows = () => {
    if ((orderData?.status === "PENDING" || orderData?.status === "CONFIRMED" || orderData?.status === "INVOICED") && (!isProcessing || !isEditing)) {
      rows.sort((a, b) => {
        const aExceedsStock = a.caseQuantity > a.availableStock.cs || a.pieceQuantity > a.availableStock.pc || a.otherUnitQuantity > a.availableStock.other;
        const bExceedsStock = b.caseQuantity > b.availableStock.cs || b.pieceQuantity > b.availableStock.pc || b.otherUnitQuantity > b.availableStock.other;

        const aNormalizedQty =
        a.caseQuantity * a.caseToPieceQty +
        a.otherUnitQuantity * a.otherToPieceQty +
        a.pieceQuantity;

        const bNormalizedQty =
          b.caseQuantity * b.caseToPieceQty +
          b.otherUnitQuantity * b.otherToPieceQty +
          b.pieceQuantity;

        const aFailsMOQ = aNormalizedQty < (a.minimumOrderQuantity ?? 0);
        const bFailsMOQ = bNormalizedQty < (b.minimumOrderQuantity ?? 0);

        if (aExceedsStock !== bExceedsStock) {
          return aExceedsStock ? -1 : 1;
        }
        if (aFailsMOQ !== bFailsMOQ) {
          return aFailsMOQ ? -1 : 1;
        }
        if (a.caseQuantity !== b.caseQuantity) {
          return b.caseQuantity - a.caseQuantity;
        }
        if (a.pieceQuantity !== b.pieceQuantity) {
          return b.pieceQuantity - a.pieceQuantity;
        }
        return b.otherUnitQuantity - a.otherUnitQuantity;
      });
      setIsProcessing(true);
    }

    setFilteredRows(rows);
  } 

  useEffect(() => {
    let filtered = filterData([...rows], searchedValue?.toLowerCase(), searchWithStatusFilter)
  
      setFilteredRows(filtered);
  }, [rows, searchedValue, searchWithStatusFilter, orderData]);

const [textSwitcherItems, setTextSwitcherItems] = useState<TextSwitcherItemObject[]>([]);

const getTextSwitcherItems = () => {
  const stockExceedingCount = countInvalidStockRows(rows, true, disableStockCheck.current);
  const moqFailCount = countInvalidMOQRows(rows, enableMOQCheck.current);

  const items: TextSwitcherItemObject[] = [
    ...(stockExceedingCount > 0 || moqFailCount > 0
      ? [{
          label: "Attention:",
          text:
            stockExceedingCount > 0 && moqFailCount > 0
              ? `${stockExceedingCount} SKUs exceed stock & ${moqFailCount} are below MOQ. Please review.`
              : stockExceedingCount > 0
              ? `${stockExceedingCount} SKUs exceed current stock availability. Review and update quickly.`
              : `${moqFailCount} SKUs are below the Minimum Billable Quantity. Please review.`,
          svgIcon: "disclaimerIcon",
          itemStyles: {
            container: { backgroundColor: "#FFF1F1" },
            text: { color: "#B54747" },
            svg: { color: "#B54747", width: "1em" },
          },
          actionButton: (
            <button
              onClick={() => sortInvalidRows()}
              style={{
                padding: "4px 8px",
                textDecoration: "underline",
                background: "none",
                color: "#1B7713",
                border: "none",
                fontWeight: 600,
              }}
            >
              Show SKUs
            </button>
          ),
        }]
      : []),
  ];

  setTextSwitcherItems(items);
};

useEffect(() => {
  getTextSwitcherItems();
}, [rows, isEditing]);


  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getOrderCancellationStatusId = () => {
    return orderTrackingConfig?.some((status: any) => status?.id?.toUpperCase() === "CANCELLED") ? "Cancelled" : "REJECTED";
  }

useEffect(() => {
  const el = scrollRef.current;
  if (!el) return;

  const handler = createScrollHandler(
    scrollRef,
    isScrolling,
    setAllowTableScroll,
    setDontContainerScroll
  );

  el.addEventListener("wheel", handler);
  el.addEventListener("scroll", handler);

  return () => {
    el.removeEventListener("wheel", handler);
    el.removeEventListener("scroll", handler);
  };
}, [isScrolling, dontAllowContainerScroll]);


  if (loader) {
    return <Loader />;
  }
  const currency = ConfigDictionary?.currency;
  const saveChangesButtonLoading = saveChangesLoading || buttonLoading(orderStatusChangeLoading, "SAVE_CHANGES") 
  
  const confirmButtonLoading = (buttonLoading(orderStatusChangeLoading, "CONFIRMED") || buttonLoading(orderStatusChangeLoading, "STOCKS")) 
  
  return (
    <>
      <div className="view_order_parent_vo" 
        onWheel={(e) => {
          if(modalOpen) return 
          handleScroll(e, setIsScrolling, scrollTop)
        }} 
        style={{width: "100%"}}
      >
        <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          leftButtonPadding={genericModalProps?.leftButtonPadding}
          onClose={resetGenericModalProps}
          loading={Boolean(orderStatusChangeLoading?.length)}
          width={genericModalProps?.width}
        />
        <EWayBillModal
          message={"Please enter the Transporter ID to proceed:"}
          leftButtonText={"Proceed"}
          rightButtonText={"Cancel"}
          onRightButtonClick={() =>
            setEWayBillModalState(eWayBillModalInitialState)
          }
          onLeftButtonClick={() => handleGenerateEWayBill()}
          onClose={() => setEWayBillModalState(eWayBillModalInitialState)}
          eWayBillModalState={eWayBillModalState}
          setEWayBillModalState={setEWayBillModalState}
          loading={buttonLoading(orderStatusChangeLoading, "E_WAY_BILL")}
        />
        {ConfigDictionary?.uomConversion && (
          <Snackbar
            open={snackbarOpen}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={5000}
            onClose={handleSnackbarClose}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity="info"
              sx={{ width: "100%" }}
            >
              {`Stock will be converted to normalized quantity for ${ insideManageInvoice ? "invoice" : "order" } editing.`}
            </Alert>
          </Snackbar>
        )}
        <ScreenOverlay apply={showOverlay} />
        <div className="view_order_header_with_search" style={{alignItems: "flex-start", marginBottom: insideManageInvoice ? 0 : "8px", position: "relative"}}>
          <div className="view_order_header">
            <FormHeader
              parentLabel={
                (currentFilterState.isFilterActive ? `Bulk Invoice - ${currentFilterState.filterType}` : insideManageInvoice ? ( ConfigDictionary?.batchIdConfiguration ?  "Manage Orders" :  "Manage Invoices") : "Manage Orders")
              }
              label={insideManageInvoice ? "Invoice Details" : "Order Details"}
              goBackToParent={() => {
                if(ConfigDictionary?.mergeManageOrderInvoice) {
                  navigate(
                    `/dashboard/sale/manageOrders`, {
                      state: {
                        isBulkPanel: isBulkPanel
                      }
                    }
                  )
                } 
                else {
                  navigate(
                    `/dashboard/sale/${
                      insideManageInvoice ? `manageInvoices` : `manageOrders`
                    }`
                  )
                }
              }
            }
            />
          </div>
          <div className="view_order_manage_order_search_bar">
            
            <SearchV2 searchFunction={handleSearchValueChange} />
          </div>
         
        </div>

        <div ref={scrollRef} style={{
            gap: "14px",
            overflow: "auto",
            height: "100%",
            scrollbarWidth: ConfigDictionary?.showTableScrollbar ? "thin" : "none",
          }}
          onScroll={(e) => {
            if (modalOpen) return
            if (ConfigDictionary?.showTableScrollbar){
              const currentScrollTop = e.currentTarget.scrollTop;
              if (currentScrollTop > scrollTop) {
                setIsScrolling(true); // scrolling down
              } else if (currentScrollTop < scrollTop) {
                setIsScrolling(false); // scrolling up
              } 
            }
          }}  
        >
          {/* <CustomAccordian
            expanded={!isScrolling}
            onCustomAccordionToggle={onCustomAccordionToggle}
            isSecondHalf={true}
            metaData1={getMetaData1([], couponLabel.current, insideManageInvoice, viewQpsFocInSummary.current)}
            data1={orderData}
            metaData2={metaData2}
            data2={orderData}
            header={
              insideManageInvoice
                ? `Invoice No. ${orderData?.invoiceNumber}`
                : `Order No. ${orderData?.orderNumber}`
            }
            redirectionUrl={
              !insideManageInvoice && !disableEditInvoiceFlow.current
                ? `/dashboard/sale/manageInvoices/viewInvoice/${
                    orderData?.orderNumber ?? ""
                  }`
                : ``
            }
            label1={insideManageInvoice ? "Invoice Summary" : "Order Summary"}
            label2="Outlet Info"
            dateAndTimeLabel={`${
              insideManageInvoice ? `Invoice` : `Order`
            } date & time`}
            dateAndTimeValue={orderData?.creationTime}
            statusConfig={orderTrackingConfig}
            status={orderData?.status}
            showOrderSource={true}
            metaData1ChunkSize={(viewQpsFocInSummary.current && insideManageInvoice) ? 5 : 4}
            rejectionReason={((orderData?.status?.toLowerCase()==="cancelled" || orderData.status?.toLowerCase()==="rejected") && orderData.statusReason) ?  orderData.statusReason : ""}
            outletApprovalData={outletApprovalData}
            isCounterSaleOrder={isCounterSaleOrder.current}
          /> */}
          
          <div style={{display: "flex", flexDirection: "column", gap: "10px", borderRadius: "10px", border: "1px solid #E7E7E7", padding: "10px"}}>
            <div style={{display: "flex", justifyContent: "space-between", margin: "0px 5px"}}>
                <div style={{display: "flex", gap: "6px", alignItems: "center"}}>
                    <span style={{fontSize: "14px", fontWeight: 500}}>
                        {
                            insideManageInvoice
                                ? `Invoice No. ${orderData?.invoiceNumber}`
                                : `Order No. ${orderData?.orderNumber}`
                        }
                    </span>
                    •
                    <span style={{fontSize: "14px", fontWeight: 500}}>
                        <span>
                            {orderData.outletName}
                        </span>
                        {" "}
                        <span style={{color: "#9F9F9F"}}>
                            {`(${orderData.outletCode})`}
                        </span>
                    </span>
                    {isCounterSaleOrder.current && (<InfoDropDown
                      approvalStatus={outletApprovalData?.status?.toUpperCase()}
                      approvedDate={outletApprovalData?.lastModifiedTime}
                      approvedBy={outletApprovalData?.currentApproverId}
                      approvalReason={outletApprovalData?.remarks}
                    />)}
                </div>
                <div style={{alignSelf: "center"}}>
                    {!hideOrderProgressCard.current && (
                    <OrderProgressCardV2
                    status={transformedStatusForProgressCardV2(orderData?.status?.toUpperCase())}
                    trackingStagesList={orderTrackingConfig}
                    stages={stagesV2}
                    insideManageInvoice={insideManageInvoice}
                    />
                )}
                </div>
            </div>
            <div>
               <CustomAccordianV2
                    metaData1={getMetaData1V2([], couponLabel.current, insideManageInvoice, viewQpsFocInSummary.current)}
                    data1={orderData}
                    outletApprovalData={outletApprovalData}
                    isCounterSaleOrder={isCounterSaleOrder.current}
                    moreDetails={[
                    {
                    title: "Distributor details",
                    items: [
                        { label: "Name", value: orderData.supplierName ?? "N/A" },
                        { label: "code", value: orderData.supplier ?? "N/A" },
                    ],
                    },
                    {
                    title: "SalesRep details",
                    items: [
                        { label: "Name", value: orderData.salesRepName ?? "N/A" },
                        { label: "code", value: orderData.salesRepId ?? "N/A" },
                    ],
                    },
                    {
                    title: "Outlet details",
                    items: [
                        { label: "Name", value: orderData.outletName ?? "N/A" },
                        { label: "code", value: orderData.outletCode ?? "N/A" },
                    ],
                    },
                    {
                    title: "Discount details",
                    items: [
                        ...(!hideCouponDiscount.current ?
                        [{ label: couponLabel.current, value: `${currency} ${truncateToTwoDecimals(orderData.couponValue ?? 0) }` }]:[]
                        ),
                        { label: "Scheme Discount", value: `${currency} ${truncateToTwoDecimals(orderData.discountValue ?? 0)}` },
                        { label: "Add. Dist. Discount", value: `${currency} ${truncateToTwoDecimals(orderData.additionalDistributorDiscount ?? 0)}` },
                    ],
                    },
                    {
                    title: `${insideManageInvoice ? "Invoice" : "Order"} details`,
                    items: [
                        { label: `${insideManageInvoice ? "Invoice" : "Order"} Date & Time`, value: orderData?.creationTime ?? "N/A" },
                    ],
                    },
                ]}
                />
            </div>
          </div>

          <div style={{height: "100%", position: "sticky", top: "0"}}>
            <div className="view_order_details_vo">
              <div className="view_order_button_container"
              style={{
               padding: "8px 0" 
              }}
              >
                <BorderHeading>
                  {insideManageInvoice ? "Invoice Details" : "Order Details"}
                </BorderHeading>
                <TextSwitcher textSwitcherItems={textSwitcherItems ?? []} interval={3000}/>
                {(orderData?.status?.toLowerCase() == "invoiced" || 
                orderData?.status?.toUpperCase() === "DELIVERED" ||
                orderData?.status?.toUpperCase() === "REJECTED" ||
                orderData?.status?.toUpperCase() === "CANCELLED" ||
                orderData?.status?.toUpperCase() === "PARTIAL DELIVERED" ||
                orderData?.status?.toUpperCase() === "OUT FOR DELIVERY")&& insideManageInvoice && (
                <Tooltip title={`${orderData?.eInvoiced ? "Print e-invoice" : "Print Invoice"} (${ctrlKey} + P)`}>
                  <button
                    className="ViewOrder_printInvoice"
                    style={{
                      whiteSpace: "nowrap",
                      cursor: (isEditing && disableActionButtons) ? "not-allowed !important" : "pointer !important",
                      pointerEvents: (isEditing && disableActionButtons) ? "none" : "auto",
                    }}
                    
                    onClick={() => {
                      if (isEditing && disableActionButtons) return
                      if (invoiceTaskName === "report") {
                        logLoadTrace(downloadReportTaskPdf,"secondary_print_invoice_download_time");
                      }else if(invoiceTaskName === "bulkInvoiceCokeNp") {
                        logLoadTrace(handlePrintInvoiceCokeNp,"secondary_print_invoice_download_time");
                      }
                      else {
                        logLoadTrace(handlePrintInvoice,"secondary_print_invoice_download_time");
                      }
                    }
                    }
                    disabled={buttonLoading(orderStatusChangeLoading, "INVOICE")}
                  >
                    <span style={{color: (isEditing && disableActionButtons) ? "#7c7c7c" : "#1D8DED"}}>{orderData?.eInvoiced ? "Print e-invoice" : "Print Invoice"}</span>&nbsp;
                    <span style={{ width: 20 }}>
                      {buttonLoading(orderStatusChangeLoading, "INVOICE") ? (
                        <CircularProgress
                          style={{
                            ...customStyle,
                            color: "#1D8DED",
                            height: 15,
                            width: 15,
                          }}
                        />
                      ) : (
                        <PdfIcon />
                      )}
                    </span>
                  </button>
                </Tooltip> 
                )}
                {orderData?.status?.toUpperCase() === "REJECTED" ||
                orderData?.status?.toUpperCase() === "CANCELLED" ||
                orderData?.status?.toUpperCase() === "OUT FOR DELIVERY" ||
                orderData?.status?.toUpperCase() === "DELIVERED" ||
                orderData?.status?.toUpperCase() === "PARTIAL DELIVERED" ||
                (orderData?.status?.toUpperCase() === "INVOICED" && !insideManageInvoice) ? (
                  <></>
                ) : (
                  <div style={{ display: "flex", gap: "8px" }}>
                    {canEditOrder() && <Tooltip title={`Reset changes (${ctrlKey} + Z)`}>
                      <span> {/* keeps Tooltip working when Button is disabled */}
                        <Button
                          className="view_order_reset_button"
                          disabled={!isEditing || editLoading || !disableActionButtons}
                          onClick={async () => {
                            if (!isEditing || editLoading) return;
                            setEditLoading(true);
                            await handleReset();
                            setEditLoading(false);
                          }}
                          sx={{
                            cursor: (isEditing && disableActionButtons) ? "pointer !important" : "not-allowed !important",
                            borderColor: (isEditing && disableActionButtons) ? "#5b6d73ff !important" : "#E2E2E2 !important",
                            color: (isEditing && disableActionButtons) ? "#227C9D !important" : "#9E9E9E !important",
                            fontWeight: 500,
                            fontSize: "12px !important",
                            textTransform: "none",
                            minHeight: "30px",
                            minWidth: "140px",
                          }}
                        >
                          <div className="view_order_icon_wrapper">
                            <RenderSvg name={"backIcon"} />
                          </div>
                          Reset changes
                        </Button>
                      </span>
                    </Tooltip>}

                    {insideManageInvoice && !isEditing ? (
                      orderData.eWayBilled ? (
                        <FormControl className="manage_order_filter">
                          <Select
                            labelId="dropdown_label"
                            size="small"
                            displayEmpty
                            value={null} 
                            sx={{
                              "& .MuiSelect-select": {
                                padding: "0px !important",
                              },
                              width: "100%",
                              fontSize: "14px",
                              padding: "0px",
                              "&.Mui-focused": {
                                boxShadow: "none",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  mt: 1,
                                  padding: 0,
                                  boxShadow: "none",
                                  border: "1px solid #DEDEDE",
                                  borderRadius: "8px",
                                },
                              },
                              MenuListProps: {
                                sx: {
                                  padding: "7px 0",
                                },
                              },
                            }}
                            renderValue={() => {
                              return (
                                <div className="ViewOrder_printInvoice" style={{width: "155px"}}>
                                  <span>Download docs</span>&nbsp;
                                  <span style={{ width: 20 }}>
                                    <PdfIcon />
                                  </span>
                                </div>
                              );
                            }}
                          >
                            <MenuItem
                              key="print-invoice"
                              className="menuItem-test-debug"
                              sx={{
                                padding: "2px 0px",
                                borderBottom: "1.5px dashed #EBEBEB",
                                margin: "0 10px",
                              }}
                            >
                              <div className="loadout_dropdown_menu_item">
                                <button
                                  className="ViewOrder_printInvoice"
                                  style={{
                                    whiteSpace: "nowrap",
                                    cursor: (isEditing && disableActionButtons) ? "not-allowed !important" : "pointer !important",
                                    pointerEvents: (isEditing && disableActionButtons) ? "none" : "auto",
                                  }}
                                  onClick={() => {
                                    if (isEditing && disableActionButtons) return
                                    if (invoiceTaskName === "report") {
                                      logLoadTrace(downloadReportTaskPdf,"secondary_print_invoice_download_time");
                                    } else {
                                      logLoadTrace(handlePrintInvoice,"secondary_print_invoice_download_time");
                                    }
                                  }}
                                  disabled={buttonLoading(
                                    orderStatusChangeLoading,
                                    "INVOICE"
                                  )}
                                >
                                  <span  style={{color: (isEditing && disableActionButtons) ? "#7c7c7c" : "#1D8DED"}}>{orderData?.eInvoiced ? "Print e-invoice" : "Print Invoice"} ({ctrlKey} + P)</span>&nbsp;
                                  <span style={{ width: 20 }}>
                                    {buttonLoading(
                                      orderStatusChangeLoading,
                                      "INVOICE"
                                    ) ? (
                                      <CircularProgress
                                        style={{
                                          ...customStyle,
                                          color: "#1D8DED",
                                          height: 15,
                                          width: 15,
                                        }}
                                      />
                                    ) : (
                                      <PdfIcon />
                                    )}
                                  </span>
                                </button>
                              </div>
                            </MenuItem>
                            <MenuItem
                              key="print-invoice"
                              className="menuItem-test-debug"
                              sx={{
                                padding: "2px 0px",
                                borderBottom: "1.5px dashed #EBEBEB",
                                margin: "0 10px",
                              }}
                            >
                              <div className="loadout_dropdown_menu_item">
                                <button
                                  className="ViewOrder_printInvoice"
                                  onClick={() => {
                                    handlePrintEWayBill();
                                  }}
                                  disabled={buttonLoading(
                                    orderStatusChangeLoading,
                                    "DOWNLOAD_E_WAY_BILL"
                                  )}
                                >
                                  <span>Print e-way bill ({ctrlKey} + P)</span>&nbsp;
                                  <span style={{ width: 20 }}>
                                    {buttonLoading(
                                      orderStatusChangeLoading,
                                      "DOWNLOAD_E_WAY_BILL"
                                    ) ? (
                                      <CircularProgress
                                        style={{
                                          ...customStyle,
                                          color: "#1D8DED",
                                          height: 15,
                                          width: 15,
                                        }}
                                      />
                                    ) : (
                                      <PdfIcon />
                                    )}
                                  </span>
                                </button>
                              </div>
                            </MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        <Tooltip title={`${orderData?.eInvoiced ? "Print e-invoice" : "Print Invoice"} (${ctrlKey} + P)`}>
                        <button
                          className="ViewOrder_printInvoice"
                          style={{
                            whiteSpace: "nowrap",
                            cursor: (isEditing && disableActionButtons) ? "not-allowed !important" : "pointer !important",
                            pointerEvents: (isEditing && disableActionButtons) ? "none" : "auto",
                          }}
                          onClick={() => {
                            if (isEditing && disableActionButtons) return
                            if (invoiceTaskName === "report") {
                              downloadReportTaskPdf();
                            } else {
                              handlePrintInvoice();
                            }
                          }}
                          disabled={buttonLoading(
                            orderStatusChangeLoading,
                            "INVOICE"
                          )}
                        >
                          <span  style={{color: (isEditing && disableActionButtons) ? "#7c7c7c" : "#1D8DED"}}>{orderData?.eInvoiced ? "Print e-invoice" : "Print Invoice"}</span>&nbsp;
                          <span style={{ width: 20 }}>
                            {buttonLoading(orderStatusChangeLoading, "INVOICE") ? (
                              <CircularProgress
                                style={{
                                  ...customStyle,
                                  color: "#1D8DED",
                                  height: 15,
                                  width: 15,
                                }}
                              />
                            ) : (
                              <PdfIcon />
                            )}
                          </span>
                        </button>
                      </Tooltip>  
                      )
                    ) : (
                      <></>
                    )}
                    {
                      (disableOrderEditDesignationBased && !insideManageInvoice && !insidePresellerLoadout) ? (
                      // Render based on designation
                      isUserAllowedToEdit(orderEditAllowedRoles) && !isEditing && isOutletApproved && canEditOrder() && (
                      <Tooltip title={`Add more (${ctrlKey} + K)`}> 
                        <Button
                          className="view_order_add_more_button"
                          variant="contained"
                          color="primary"
                          onClick={handleClickAddMore}
                           sx={{
                        minHeight: "30px",
                        maxHeight: "30px",
                      }}
                        >
                          <ShoppingCartIcon className="view_order_cart_icon" />
                          Add more 
                        </Button>
                      </Tooltip>
                      )
                    ):(
                  
                    !isEditing &&
                      !orderData?.eInvoiced &&
                      !hideAddMoreInEditOrder.current &&
                      !invoiceExpired &&
                      isOutletApproved && 
                      !insidePresellerLoadout && canEditOrder() && (
                        <Button
                          className="view_order_add_more_button"
                          variant="contained"
                          color="primary"
                          onClick={handleClickAddMore}
                          sx={{
                        minHeight: "30px",
                        maxHeight: "30px",
                      }}
                        >
                          <ShoppingCartIcon className="view_order_cart_icon" />
                          Add more
                        </Button>
                      ))}
                       {/* Additional Add more button - only when editing is active */}
                {isEditing && canEditOrder() && (
                  <Button
                    className="view_order_add_more_button"
                    variant="contained"
                    color="primary"
                    onClick={handleClickAddMore}
                    sx={{
                      minHeight: "30px",
                      maxHeight: "30px",
                    }}
                  >
                    <ShoppingCartIcon className="view_order_cart_icon" />
                    Add more
                  </Button>
                )}
                  </div>
                )}
              </div>
          
            

            {loader ? (
              <Loader />
            ) : (
              <CustomTablewithTotalInfoV2
                editLoading={editLoading }
                hasRealChanges={disableActionButtons}
                allowTableScroll = {allowTableScroll}
                isScrolling={isScrolling}
                setScrollTop={setScrollTop}
                data={filteredRows}
                columns={columns}
                expandableRowColumns={expandableRowColumns}
                totals={totalFooterValue}
                headerBackgroundColor="#F0FBFF"
                isEditing={isEditing}
                children={
                  <div style={{display: "flex", alignItems: "center", gap: "10px"}}>

                    {isOutletApproved ? (
                      insideManageInvoice &&
                      (orderData?.status?.toUpperCase() === "INVOICED" ||
                        orderData?.status?.toUpperCase() === "PARTIALLY INVOICED") ? (
                        (
                          <div
                            className="view_order_update_wrapper" 
                            style={{ width: "100%", position: "static" }}
                          >
                            <div className="view_order_action_buttons_wrapper" style={{gap:"5px"}}>
                              {isEditing && (
                                <>
                                  {disableActionButtons && (
                                    <span style={{ marginRight: "8px", textWrap: "nowrap", padding: "4px 8px", borderRadius: "20px", background: "#FFF7F7", color: "#B54747", fontSize: "11px" }}>
                                      * Tax, promos, and amount update after saving changes.
                                    </span>
                                  )}

                                  {canEditOrder() && <Button
                                    className="view_order_action_button"
                                    key="CONFIRMED"
                                    disabled={saveChangesButtonLoading || !disableActionButtons} 
                                    sx={{
                                      cursor: disableActionButtons
                                        ? "pointer !important"
                                        : "not-allowed !important",
                                      color: "#ffffff !important",
                                      fontWeight: 500,
                                      fontSize: "12px !important",
                                      backgroundColor: disableActionButtons
                                        ? "#227C9D !important"
                                        : "#E2E2E2 !important",
                                      letterSpacing: "0.0001rem",
                                      textTransform: "none",
                                      minHeight: "35px",
                                      minWidth: "75px",
                                    }}
                                    onClick={handleClickSaveChanges}
                                  >
                                    {saveChangesButtonLoading ? (
                                      <CircularProgress style={customStyle} />
                                    ) : (
                                      "Save"
                                    )}
                                  </Button>}
                                </>
                              )}
                              {!insidePresellerLoadout && (
                                <button
                                  className="ViewOrder_invoicedButtons ViewOrder_invoicedButtons_cancelInvoice"
                                  onClick={() => setOrderCancelModalOpen(true)}
                                  disabled={disableActionButtons}
                                >
                                  {buttonLoading(orderStatusChangeLoading, "CANCELLED") ? (
                                    <CircularProgress
                                      style={{ ...customStyle, color: "#c64c01" }}
                                    />
                                  ) : (
                                    `Cancel ${
                                      orderData.eWayBilled
                                        ? "e-way bill"
                                        : orderData.eInvoiced
                                        ? "e-invoice"
                                        : "Invoice"
                                    }`
                                  )}
                                  {!buttonLoading(orderStatusChangeLoading, "CANCELLED") && (
                                    <span style={{ fontSize: "9.5px" }}>
                                      &nbsp;{negativeCta}
                                    </span>
                                  )}
                                </button>
                              )}

                              <Tooltip
                                title={`${
                                  orderData.eInvoiced ? "View e-invoice" : "View Invoice"
                                } (${ctrlKey} + Shift + P)`}
                                placement="top"
                              >
                                <button
                                  className="ViewOrder_invoicedButtons ViewOrder_invoicedButtons_viewInvoice"
                                  onClick={() =>
                                    logLoadTrace(
                                      () => handlePrintInvoice(true),
                                      "secondary_view_invoice_time"
                                    )
                                  }
                                  disabled={buttonLoading(orderStatusChangeLoading, "VIEW_INVOICE") || disableActionButtons}
                                >
                                  {buttonLoading(orderStatusChangeLoading, "VIEW_INVOICE") && (
                                    <CircularProgress
                                      style={{
                                        ...customStyle,
                                        color: "#00C6B1",
                                        width: 14,
                                        height: 14,
                                      }}
                                    />
                                  )}{" "}
                                  &nbsp;&nbsp;
                                  {orderData.eInvoiced ? "View e-invoice" : "View Invoice"}
                                </button>
                              </Tooltip>

                              {orderData.eWayBilled && (
                                <button
                                  className="ViewOrder_invoicedButtons ViewOrder_invoicedButtons_viewInvoice"
                                  onClick={() => handlePrintEWayBill(true)}
                                  disabled={buttonLoading(orderStatusChangeLoading, "VIEW_E_WAY_BILL") || disableActionButtons}
                                >
                                  {buttonLoading(orderStatusChangeLoading, "VIEW_E_WAY_BILL") && (
                                    <CircularProgress
                                      style={{
                                        ...customStyle,
                                        color: "#00C6B1",
                                        width: 14,
                                        height: 14,
                                      }}
                                    />
                                  )}{" "}
                                  &nbsp;&nbsp;
                                  {"View e-way bill"}
                                </button>
                              )}

                              {canPushToEInvoice && !orderData?.eInvoiced && (
                                <button
                                  className="ViewOrder_invoicedButtons ViewOrder_invoicedButtons_pushToEInvoice"
                                  onClick={handleClickPushToEInvoice}
                                  disabled={disableActionButtons}
                                >
                                  {buttonLoading(orderStatusChangeLoading, "E_INVOICE") ? (
                                    <CircularProgress style={customStyle} />
                                  ) : (
                                    "Push to e-Invoice"
                                  )}
                                </button>
                              )}

                              {orderData?.eInvoiced && !orderData?.eWayBilled && (
                                <button
                                  className="ViewOrder_invoicedButtons ViewOrder_invoicedButtons_pushToEInvoice"
                                  onClick={handleClickGenerateEWayBill}
                                  disabled={disableActionButtons}
                                >
                                  {buttonLoading(orderStatusChangeLoading, "E_WAY_BILL") ? (
                                    <CircularProgress style={customStyle} />
                                  ) : (
                                    "Generate e-way bill"
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                        )
                      ) : orderData?.status?.toLowerCase() === "pending" &&
                        !Boolean(disableOrderStatusChange.current) ? (
                        <div className="view_order_action_buttons_wrapper" style={{gap:"5px"}}>
                           {isEditing && (
                              <>
                                {disableActionButtons && (
                                  <span style={{ marginRight: "8px", textWrap: "nowrap", padding: "4px 8px", borderRadius: "20px", background: "#FFF7F7", color: "#B54747", fontSize: "11px" }}>
                                    * Tax, promos, and amount update after saving changes.
                                  </span>
                                )}

                                {canEditOrder() && <Button
                                  className="view_order_action_button"
                                  key="CONFIRMED"
                                  disabled={saveChangesButtonLoading || !disableActionButtons}
                                  sx={{
                                    cursor: disableActionButtons
                                      ? "pointer !important"
                                      : "not-allowed !important",
                                    color: "#ffffff !important",
                                    fontWeight: 500,
                                    fontSize: "12px !important",
                                    backgroundColor: disableActionButtons
                                      ? "#227C9D !important"
                                      : "#E2E2E2 !important",
                                    letterSpacing: "0.0001rem",
                                    textTransform: "none",
                                    minHeight: "35px",
                                    minWidth: "75px",
                                  }}
                                  onClick={handleClickSaveChanges}
                                >
                                  {saveChangesButtonLoading ? (
                                    <CircularProgress style={customStyle} />
                                  ) : (
                                    "Save"
                                  )}
                                </Button>}
                              </>
                            )}
                          <Button
                            startIcon={buttonLoading(orderStatusChangeLoading, "REJECTED") ? "" : <RenderSvg name={"viewOrderREJECTED"} />}
                            className="view_order_action_button"
                            key={"REJECTED"}
                            sx={{
                              minWidth: "100px",
                              color: `#ffffff !important`,
                              fontWeight: 500,
                              fontSize: `12px !important`,
                              backgroundColor: disableActionButtons ? "#E2E2E2" : "#C64C00",
                              border: `1px solid ${disableActionButtons ? "#E2E2E2" : "#C64C00"}`,
                              cursor: disableActionButtons ? "not-allowed" : "pointer",                              
                              letterSpacing: "0.0001rem",
                              paddingLeft: "12px",
                              "&:hover": {
                                backgroundColor: `#C64C00 !important`,
                              },
                              textTransform: "none",
                            }}
                            onClick={() => setOrderCancelModalOpen(true)}
                            disabled={buttonLoading(orderStatusChangeLoading, "REJECTED") || disableActionButtons}
                          >
                            {buttonLoading(orderStatusChangeLoading, "REJECTED") ? (
                              <CircularProgress style={customStyle} />
                            ) : (
                              "Cancel"
                            )}
                            &nbsp;<span style={{fontSize:"9.5px"}}>{negativeCta}</span>
                          </Button>
                          {((!orderConfirmationEnabled.current)) ? (<InvoiceOrGrnButton showPushToGrnButton={false} handleCreateInvoice={handleCreateInvoice} orderStatusChangeLoading={orderStatusChangeLoading?.length > 0} handleModalOpen={handleModalOpen} openingInvoiceModal={openingInvoiceModalState} disabled={disableActionButtons}/>) : (<Button
                            startIcon={confirmButtonLoading ? "" : <RenderSvg name={"viewOrderCONFIRMED"} />}
                            className="view_order_action_button"
                            key={"CONFIRMED"}
                            sx={{
                              minWidth: "100px",
                              color: `#ffffff !important`,
                              fontWeight: 500,
                              fontSize: `12px !important`,
                              backgroundColor: disableActionButtons ? "#E2E2E2" : "#00C6B1",
                              border: `1px solid ${disableActionButtons ? "#E2E2E2" : "#00C6B1"}`,
                              cursor: disableActionButtons ? "not-allowed" : "pointer",
                              paddingLeft: "12px",
                              letterSpacing: "0.0001rem",
                              "&:hover": {
                                backgroundColor: `#00C6B1 !important`,
                              },
                              textTransform: "none",
                            }}
                            onClick={handleClickAccept}
                            disabled={confirmButtonLoading || disableActionButtons}
                          >
                            {confirmButtonLoading  ? (
                              <CircularProgress style={customStyle} />
                            ) : (
                              "Confirm" 
                            )}&nbsp;<span style={{fontSize:"9.5px"}}>{positiveCta}</span>
                          </Button>)}
                        </div>
                      ) : orderData?.status?.toLowerCase() === "confirmed" ||
                        orderData?.status?.toLowerCase() === "partially confirmed" ? (
                        (
                          <div className="view_order_action_buttons_wrapper">
                            {isEditing && canEditOrder() && <Button
                              className="view_order_action_button"
                              key={"CONFIRMED"}
                              disabled={saveChangesButtonLoading || !disableActionButtons}
                              sx={{
                                cursor: `${
                                  disableActionButtons ? "pointer !important" : "not-allowed !important"
                                }`,
                                color: "#ffffff !important",
                                fontWeight: 500,
                                fontSize: `12px !important`,
                                backgroundColor: `${
                                  disableActionButtons ? "#227C9D !important" : "#E2E2E2 !important"
                                }`,
                                letterSpacing: "0.0001rem",
                                textTransform: "none",
                                minHeight: "35px",
                                minWidth: "108px"
                              
                              }}
                              onClick={handleClickSaveChanges}
                            >
                              {saveChangesButtonLoading? <CircularProgress style={customStyle} /> : "Save" }
                              &nbsp;<span style={{fontSize:"9.5px"}}>{positiveCta}</span>
                            </Button>}
                            <Button
                              className="view_order_action_button"
                              key={"REJECTED"}
                              disabled={disableActionButtons}
                              sx={{
                                minWidth: "100px",
                                color: `#ffffff !important`,
                                fontWeight: 500,
                                fontSize: `12px !important`,
                                backgroundColor: `#C64C00 !important`,
                                border: `1px solid #C64C00 !important`,
                                cursor: "pointer",
                                "&:hover": {
                                  backgroundColor: `#C64C00 !important`,
                                },
                                letterSpacing: "0.0001rem",
                                paddingLeft: "12px",
                                textTransform: "none",
                              }}
                              onClick={() => setOrderCancelModalOpen(true)}
                            >
                              {buttonLoading(orderStatusChangeLoading, "REJECTED") ? (
                                <CircularProgress style={customStyle} />
                              ) : (
                                `Cancel Order`
                              )}
                              {!buttonLoading(orderStatusChangeLoading, "REJECTED") && (
                                <span style={{ fontSize: "9.5px" }}>&nbsp;{negativeCta}</span>
                              )}
                            </Button>

                            {!isUserNotAllowedToCreateInvoice() && (
                              <InvoiceOrGrnButton
                                disabled={disableActionButtons}
                                showPushToGrnButton={false}
                                handleCreateInvoice={handleCreateInvoice}
                                orderStatusChangeLoading={orderStatusChangeLoading?.length > 0}
                                handleModalOpen={handleModalOpen}
                              />
                            )}
                          </div>
                        )
                      ) : orderData?.status?.toLowerCase() === "invoiced" &&
                        showGoToInvoiceRedirectionButton.current ? (
                        <div className="CreateBulkInvoiceFooter_container">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(
                                `/dashboard/sale/manageInvoices/viewInvoice/${
                                  orderData?.orderNumber ?? ""
                                }`
                              );
                            }}
                            className="button-save-claim"
                            style={{
                              width: "fit-content",
                              height: "35px",
                              padding: "0 10px",
                              cursor: "pointer",
                            }}
                          >
                            <span
                              className="button-save-text-claim"
                              style={{
                                fontWeight: 500,
                                color: "#ffffff",
                                fontSize: "14.5px",
                              }}
                            >
                              Go To Invoice
                            </span>
                            &nbsp;
                            <span style={{ fontSize: "11px", color: "#ffffff" }}>
                              {positiveCta}
                            </span>
                          </button>
                        </div>
                      ) : (
                        <></>
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                }
              />
            )}
            
            </div>
          </div>
        </div>
        
        {
          performSkuReplacement.current ? 
          <CreateInvoiceModalReplacementSKU
            handleModalClose={handleModalClose}
            modalOpen={modalOpen}
            orderData={orderData}
            handleOnSave={handleCreateInvoice}
            discount={discount}
            setDiscount={setDiscount}
            invoiceLoading={buttonLoading(orderStatusChangeLoading, "INVOICE")}
            hideAdditionalDistributorDiscount={hideAdditionalDistributorDiscount?.current}
            originalSkuFulfillmentMap={originalSkuFulfillmentMapRef.current}
            newOrderData={newOrderDataAfterReplacement.current}
            skuNameMap={skuNameMap.current}
            orderWillGet={willGetRejected.current ? "REJECTED" : willOrderGetPartiallyInvoiced.current ? "PARTIALLY INVOICED" : "INVOICED"}
          />
          :
          <CreateInvoiceModal
            handleModalClose={handleModalClose}
            modalOpen={modalOpen}
            orderData={orderData}
            handleOnSave={handleCreateInvoice}
            discount={discount}
            setDiscount={setDiscount}
            invoiceLoading={buttonLoading(orderStatusChangeLoading, "INVOICE")}
            hideAdditionalDistributorDiscount={hideAdditionalDistributorDiscount?.current}
            orderWillGet={willGetRejected.current ? "REJECTED" : willOrderGetPartiallyInvoiced.current ? "PARTIALLY INVOICED" : "INVOICED"}
            hideCouponDiscount={hideCouponDiscount.current}
          />
        }
        
      </div>
      <NewDiscountModal skuData={orderData} selectedSkuCode={selectedSkuCode} isEditing={isEditing} insideManageInvoice={insideManageInvoice} />

      <OrderCancelModal
        headerText={
    orderData.eWayBilled
      ? "e-Way bill is being cancelled."
      : orderData.eInvoiced
      ? "e-Invoice is being cancelled."
      : `${insideManageInvoice ? `Invoice` : `Order`} is being cancelled.`
  }
        modalOpen={orderCancelModalOpen}
        selectedRejectionReason={selectedRejectionReason}
        loading={
          buttonLoading(orderStatusChangeLoading, "CANCELLED") ||
          buttonLoading(orderStatusChangeLoading, "REJECTED")
        }
        rejectionReasons={rejectionReasons}
        onClose={resetRejectOrderState}
        handleReasonChange={handleReasonChange}
        onButtonClick={() =>
          logLoadTrace(
            () => handleOrderStatusChange(
              insideManageInvoice ? "CANCELLED" : getOrderCancellationStatusId()
            ),
            insideManageInvoice
              ? "secondary_order_reject_invoice_time"
              : "secondary_order_reject_order_time"
          )
        }
        inputActive={ (orderData?.eInvoiced || orderData.eWayBilled) &&  cancelEInvoiceAndEWayBillRejectionReasons[selectedRejectionReason] === "4" }
        inputString={rejectionReasonString}
        handleReasonStringChange={handleReasonStringChange}
      />
    </>
  );
};

export default ViewOrderV2;
